import { useState, useEffect, useRef, useCallback } from "react";
import { Row, Col, message, Tooltip, Modal, Spin, Layout, Progress, Input, Card, Button, Tag, Form } from "antd";
import {
  LoadingOutlined,
  ArrowLeftOutlined,
  MoreOutlined,
  CustomerServiceOutlined,
  SearchOutlined,
  CloseOutlined,
  EditOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import _, { get } from "lodash";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import All from "../../../assets/images/all.svg";
import ParkedOrder from "../../../assets/images/parkedOrder.svg";
import InProgress from "../../../assets/images/inProgress.svg";
import Pending from "../../../assets/images/pending.svg";
import Prepared from "../../../assets/images/prepared.svg";
import Completed from "../../../assets/images/completed.svg";
import BackIcon from "../../../assets/images/backIcon.svg";
import Logo from "../../../assets/images/logo-without-bg.png";
import AddUser from "../../../assets/images/userAdd.svg";
import CustomerSearch from "../../../assets/images/search.png";
import CustomerIcon from "../../../assets/images/userId.svg";
import View from "../../../assets/images/view.svg";
import Logout from "../../../assets/images/logout.png";
import leftLoading from "../../../assets/images/opo.gif";
import SyncIcon from "../Retail/SvgComponent/SyncIcon";
import TableDineIN from "./SvgComponents/TableDineIn";
import TakeAway from "./SvgComponents/TakeAway";
import TableMenu from "./SvgComponents/TableMenu";
import TableCustomer from "./SvgComponents/TableCustomer";
import CashManagementIcon from "../Retail/SvgComponent/CashManagementIcon";
import unlinkTill from "../../../assets/images/unlink-icon.svg";
import openDrawerIcon from "../../../assets/images/openDrawer.svg";
import printerIcon from "../../../assets/images/printerIcon.svg";
import data from "../../../constants/retailPos.json";
import db from "../../../database";
import { clock } from "../../../utility/clock";
import RestaurantModals from "./RestaurantModals";
import moment from "moment";
import { kotPrinter } from "../../../lib/printer/kotPrinter";
import CWKOTPrinter from "../../../lib/printer/CWKotPrinter";
import { SyncData } from "./Tables-Management/SyncData";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";
import MenuLayout from "./MenuLayout";
import CashManagement from "./cashManagement";
import OrderListComponent from "./OrderListComponent";
import { useGlobalContext } from "../../../lib/auth/globalStore";
import { processSync } from "../../Sync/syncData";
import TableManagement from "./Tables-Management/tables";
import TableOrder from "./SvgComponents/TableOrder";
import CustomersComponent from "./CustomersComponent";
import HomeDeliveryComponent from "./HomeDeliveryComponent";
import { useTranslation } from "react-i18next";
import RetailModals from "../Retail/RetailModals";
import { getMultilingualText } from "../../../utility/getMultilingualText ";
import { useEventBus } from "../../../lib/hooks/EventBusProvider";
import { timeStamp } from "../../../utility/clock";
import { getNewOmsOrder, updateOMSOrderStatus, upsertWaitlist, getWaitlist, getTableReservation } from "../../../services";
import messages from "../../../errors/messages.en-IN.json";
import salesReportIcon from "../../../assets/images/salesReportIcon.svg";
import { getWorkflowData } from "../../../utility/getWorkflowData";
import TableFeatures from "./Tables-Management/TableFeatures";
import { getCustomer, createCustomer } from "../Core/customer";
import useRestaurantWebSocket from "../../../hooks/use-websocket";
import { showKDSNotification } from "./showKDSNotification";
import { numberToWords } from "../../../utility/numberToWords";
import Scrollbars from "react-custom-scrollbars";

const FBLayout = (props) => {
  const {
    salesReportCWHCPrinter,
    salesReportPrinter,
    filteredPaymentMethods,
    getFilteredPaymentMethods,
    handleSelectedSaleTypeForProducts,
    selectedSaleType,
    setSelectedSaleType,
    saleTypeProducts,
    setSaleTypeProducts,
    cart,
    setCart,
    decreaseProductQty,
    deleteCart,
    setGiftCardData,
    deleteProduct,
    increaseProductQty,
    openDisplayParkedBillModal,
    openPaymentModal,
    orderType,
    selectProductCategory,
    selectProductInCart,
    selectedProductInCart,
    setSelectedProductInCart,
    setDisplayCustomerSearch,
    tillData,
    currencyType,
    setManualDiscountInput,
    manualDiscountModalVisible,
    setManualDiscountModalVisible,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    setAddCashFlag,
    requestPayment,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    amount,
    setAmount,
    setNumb,
    processOrder,
    handleAmount,
    handleCashPayment,
    setCashAddInFlag,
    pickProduct,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    documentSequence,
    setDocumnetSequence,
    productsData,
    setProductsData,
    allProductCategories,
    orderTypeSelection,
    setOrderTypeSelection,
    addDefinedProductWithAddons,
    setManualDiscountTypes,
    manualDiscountForm,
    setSelectedManualDiscountTypeValue,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    showProducts,
    setShowProducts,
    keyValue,
    setKeyValue,
    tableCards,
    setTableCards,
    clearCart,
    splitCarts,
    setSplitCarts,
    dynamicForm,
    setDynamicForm,
    setSaleType,
    saleType,
    selectedItemsModalOpen,
    setSelectedItemsModalOpen,
    notesValue,
    setNotesValue,
    selectedProductForNotes,
    setIsInputFocused,
    keyboardRef,
    setSelectedProductForNotes,
    searchOrderHistory,
    orderHistoryDetails,
    setOrderHistoryDetails,
    getSalesHistoryData,
    isPrintModeXML,
    upsertPOSLog,
    setFiltersFlag,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    searchHistoryInput,
    setSearchhistoryInput,
    ordersCopy,
    dateRef,
    filtersFlag,
    callCenterVisible,
    setCallCenterVisible,
    removeCutomer,
    showAddNewCustomerFields,
    setProductSearchInput,
    customerId,
    setCloseCustomerFlag,
    setCustomerSearchResults,
    setCustomerSearchInput,
    handleCustomerSearch,
    showEditOldCustomerFields,
    setEditFlag,
    setKeyboardInputFields,
    keyboardInputFields,
    displayCustomerSearch,
    isCallCenterFlow,
    setIsCallCenterFlow,
    showCallCenterPage,
    setShowCallCenterPage,
    holdQueue,
    setHoldQueue,
    handleCopyKOT,
    onCancel,
    guestForm,
    kioskLogin,
    setKioskUI,
    addNewCustomer,
    copyKOTVisible,
    setCopyKOTVisible,
    groupedFiredItems,
    setGroupedFiredItems,
    openCopyKOTModal,
    selectedCopyItems,
    setSelectedCopyItems,
    filterdParkedList,
    setFilterdParkedList,
    retrieveParkedData,
    discardMessage,
    parkedList,
    setParkedList,
    displayAddOnSelection,
    setDisplayAddOnSelection,
    addonSourceItem,
    setAddonSourceItem,
    showAddonsCustomizePopup,
    setShowAddonsCustomizePopUp,
    addonRepeatDisabled,
    setAddonRepeatDisabled,
    selectedReturnOrder,
    setSelectedReturnOrder,
    setCheckedKeys,
    checkedKeys,
    addSelectedReturnProductsToCart,
    getProductData,
    handleSaveReturnCartRecord,
    dataSource,
    setDataSource,
    showReturnPurchase,
    setShowReturnPurchase,
    selectPurchaseBillForReturn,
    retrunSearchType,
    setReturnSearchType,
    searchReturnHistory,
  } = props;
  const history = useHistory();
  const { t } = useTranslation();
  const username = localStorage.getItem("username");
  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
  const matchedRep = salesReps.find((rep) => rep.name === username);
  const domainURL = process.env.REACT_APP_domain;
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const { globalStore, setGlobalStore } = useGlobalContext();
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage } = globalStore;
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const accessController = JSON.parse(tillData?.tillAccess?.cwrTill?.accessController);
  // SAVING BILL BLOCK START //
  const storedLocatedList = JSON.parse(localStorage.getItem("locatedList"));
  const initialLocatedList = storedLocatedList ? storedLocatedList : [];
  const [locatedList, setLocatedList] = useState(initialLocatedList);
  const [selectedTable, setSelectedTable] = useState(
    JSON.parse(localStorage.getItem("tableName")) !== "null" ? JSON.parse(localStorage.getItem("tableName")) : history?.location?.state || ""
  );
  const [orderedData, setOederedData] = useState([]);
  const [tempProducts, setTempProducts] = useState([]);
  const [orderCanceled, setOrderCanceled] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const [paymentVisible, setPaymentVisible] = useState(false);
  const [showOrderCompleteFlag, setShowOrderCompleteFlag] = useState(false);
  const [syncLoad, setSyncLoad] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const [clock1, setClock1] = useState(clock());
  // const [showProducts, setShowProducts] = useState(false);
  const [occupiedDataTablesData, setOcupiedTablesData] = useState([]);
  const [reservedTablesData, setReservedTablesData] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [tableList, setTableList] = useState([]);
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const userPreferences = JSON.parse(localStorage.getItem("userPreferences")) || { dateFormat: "DD-MM-YYYY", dateTimeFormat: "DD-MM-YYYY HH:mm:ss" };
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const { dispatchEvent } = useEventBus();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const tillValue = JSON.parse(localStorage.getItem("tillValue"));
  const defaultCustomer = tillData.tillAccess.csBunit.b2cCustomer;
  const [showSplitBill, setShowSplitBill] = useState(false);
  const [splitBillScreen, setSplitBillScreen] = useState(false);
  const [numSplits, setNumSplits] = useState(2);
  const [showAllItems, setShowAllItems] = useState(true);
  const [isSplitBill, setIsSplitBill] = useState(false);
  const [currentSplitIndex, setCurrentSplitIndex] = useState(0);
  const [recordState, setRecardState] = useState("");
  const [removeSplit, setRemoveSplit] = useState([]);
  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y" ? true : false;
  const [mainTableData, setMainTableData] = useState([]);
  const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
  const [selectedProducts, setSelectedproducts] = useState([]);
  const [showSendToKitchen, setShowSendToKitchen] = useState(false);
  const [guestsModalFlag, setGuestsModalFlag] = useState(false);
  const [noOfPersons, setNumberOfPersons] = useState("");
  const [priorityBtn, setPriorityBtn] = useState(false);
  const [orderFlags, setOrderFlags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fireItems, setFireItems] = useState([]);
  const [fireMode, setFireMode] = useState("single");
  const [pendingFireItems, setPendingFireItems] = useState([]);
  const [waitlistTab, setWaitlistTab] = useState("current");
  const [waitlistForm, setWaitlistForm] = useState({
    name: "",
    phone: "",
    guests: "",
    eta: "",
  });
  const [waitlistErrors, setWaitlistErrors] = useState({});
  const [waitlistList, setWaitlistList] = useState([]);
  const [form, setForm] = useState({
    guestName: "",
    phone: "",
    resDate: null,
    resTime: null,
    guestCount: null,
    specialReq: "",
    tableNum: "",
    section: "",
  });
  const [reservationList, setReservationList] = useState([]);
  const [errors, setErrors] = useState({});
  const [fbTableId, fbSectionId] = form.tableNum ? form.tableNum.split("-") : [null, null];
  const [reserveModalOpen, setReserveModalOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [waitlistDrawerOpen, setWaitlistDrawerOpen] = useState(false);
  const [isNewGuestCustomer, setIsNewGuestCustomer] = useState(false);
  const [reservationsBlank, setReservationsBlank] = useState(false);
  const [mergeDrawerOpen, setMergeDrawerOpen] = useState(false);
  const [selectData, setSelectData] = useState([]);
  const [displayReserveTablesPopup, setDisplayReserveTablesPopup] = useState(false);
  const [radioValue, setRadioValue] = useState({ value: "all", name: "All" });
  const [inputFields, setInputFields] = useState({});
  const [guestMobile, setGuestMobile] = useState("");
  const [reservePhone, setReservePhone] = useState("");
  const [seatGuestDrawerOpen, setSeatGuestDrawerOpen] = useState(false);
  const [transferBill, setTransferBill] = useState(false);
  const [cancelKotItems, setCancelKotItems] = useState(false);
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const [saleTypesInfo, setSaleTypesInfo] = useState([]);
  const [selectedSaleTypeIndex, setSelectedSaleTypeIndex] = useState(null);

  const getDefaultSaleType = async () => {
    const saleData = await db.posSaletypes.toArray();
    const defaultSale = saleData.find((sale) => sale?.cwrSaletype?.isdefault === "Y");
    if (defaultSale) return defaultSale;
    const dineInSale = saleData.find((sale) => sale?.cwrSaletype?.fulfilmentType === "DI");
    if (dineInSale) return dineInSale;
    const takeAwaySale = saleData.find((sale) => sale?.cwrSaletype?.fulfilmentType === "TA");
    if (takeAwaySale) return takeAwaySale;
    return saleData[0]; // Fallback to first sale type if none found
  };

  useEffect(async () => {
    const initializeCart = async () => {
      const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
      if (cartDetails?.preOrder === "Y") {
        localStorage.setItem("dineIn", "N");
        setKeyValue("2");
        const saleData = await db.posSaletypes.toArray();
        const takeAwaySaleType = saleData.find((st) => st?.cwrSaletype?.fulfilmentType === "TA");

        if (takeAwaySaleType) {
          const index = saleData.findIndex((st) => st?.cwrSaletype?.fulfilmentType === "TA");
          setSelectedSaleTypeIndex(1);
          await handleSelectedSaleTypeForProducts(takeAwaySaleType)();
          setCart(cartDetails);
          localStorage.setItem("cartObj", JSON.stringify(cartDetails));

          setSaleType("TA");
          // handleKeyvalue("2", "TA");
        }
      } else {
        const defaultSaleType = await getDefaultSaleType();
        const cartData = {
          items: [],
          couponInput: [],
          total: 0,
          tax: 0,
          discount: 0,
          paid: 0,
          change: 0,
          totalQty: 0,
          roundOff: 0,
          payments: [],
          redemptionPoints: 0,
          accumulationPoints: 0,
          creditAmount: 0,
          sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
          referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
          giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          customer: defaultSaleType?.customer?.b2cCustomerId ? defaultSaleType.customer : tillData.tillAccess.csBunit.b2cCustomer,
          couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          salesRepId: null,
          cardPaymentData: {},
          documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
          userName: userData.user,
          tillName: tillValue?.name,
          subTotal: 0,
          itemsSummery: {},
          amountInWords: "",
          groupedItemsByTaxRate: {},
          serviceCharge: 0,
          tip: 0,
          deiveryCharge: 0,
          packingCharge: 0,
        };
        localStorage.setItem("cartObj", JSON.stringify(cartData));
        setCart(cartData);
      }
    };
    initializeCart();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.shiftKey && event.key === "+") {
        setDynamicForm(false); // Close the modal
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [dynamicForm]);

  useEffect(() => {
    db.pricingRules.toArray().then((pr) => {
      const manualPricingRules = pr.filter((rule) => rule.manualDiscount === "Y");
      setManualDiscountTypes([...manualPricingRules]);
    });
  }, []);
  const numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10+"];
  const [reserveTableForm] = Form.useForm();

  const handleReserveTable = () => {
    // 💥 Reset Guest Modal inputs BEFORE opening it
    guestForm.resetFields(); // reset form inputs like Guest Name, No. of Guests, etc.
    setGuestMobile(""); // reset mobile input
    setInputFields({}); // reset your custom input fields state
    setNumberOfPersons("");

    // ⭐ Your existing code
    let newTime = moment(new Date());
    reserveTableForm.setFieldsValue({ section: radioValue.value, time: newTime });

    // Finally open the drawer / popup
    setDisplayReserveTablesPopup(true);
  };

  const handleNumberClick = (number) => {
    setNumberOfPersons(number);
    reserveTableForm.setFieldsValue({ noOfPersons: number });
  };

  const handleClick = () => {
    setNumberOfPersons("");
    setDisplayReserveTablesPopup(false);
    setInputFields("");
    reserveTableForm.resetFields();
    setGuestsModalFlag(false);
  };
  const handleOnChange = (key) => {
    let tempData = [];
    if (key === "all") {
      tempData.push(...mainTableData);
    } else {
      mainTableData.map((e) => {
        if (e.cwrFbsectionId === key) {
          tempData.push(e);
        }
      });
    }
    setTableList(tempData);
  };

  const clearCartData = {
    items: [],
    couponInput: [],
    advancePayment: 0,
    total: 0,
    tax: 0,
    discount: 0,
    paid: 0,
    change: 0,
    totalQty: 0,
    roundOff: 0,
    payments: [],
    redemptionPoints: 0,
    accumulationPoints: 0,
    creditAmount: 0,
    docType: "Invoice",
    sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
    referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
    giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    customer: defaultCustomer,
    salesRepId: null,
    cardPaymentData: {},
    // documentno: cart.documentno,
    documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
    userName: userData.user,
    tillName: tillValue?.name,
    subTotal: 0,
    itemsSummery: {},
    amountInWords: "",
    groupedItemsByTaxRate: {},
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;

    setKeyboardInputFields({
      ...keyboardInputFields,
      [inputName]: inputVal,
    });

    keyboard?.current?.setInput(inputVal);
  };

  useEffect(() => {
    const getSaleTypeData = async () => {
      const saleData = await db.posSaletypes.toArray();
      const filteredSaleData = saleData?.filter(
        (sale) => sale?.cwrSaletype?.fulfilmentType === "TA" || sale?.cwrSaletype?.fulfilmentType === "DI" || sale?.cwrSaletype?.fulfilmentType === "DE"
      );
      setSaleTypesInfo(filteredSaleData);
    };

    getSaleTypeData();
  }, []);

  const fulfilmentPriority = ["DI", "TA", "DE"];
  const fulfilmentToKeyMap = {
    DI: "0",
    DE: "1",
    TA: "2",
  };

  const fulfilmentIconMap = {
    DI: TableDineIN,
    TA: TableMenu,
    DE: TakeAway,
  };

  const sortedSaleTypes = [...(saleTypesInfo || [])].sort((a, b) => {
    return fulfilmentPriority.indexOf(a?.cwrSaletype?.fulfilmentType) - fulfilmentPriority.indexOf(b?.cwrSaletype?.fulfilmentType);
  });

  const defaultFulfilmentType = fulfilmentPriority.find((type) => sortedSaleTypes.some((st) => st?.cwrSaletype?.fulfilmentType === type));

  useEffect(() => {
    const fetchAndHandleSaleType = async () => {
      try {
        let selectedSaleTypeArray;
        if (keyValue === "0") {
          if (posConfig?.enableDineIn === "Y") {
            selectedSaleTypeArray = await getSaleTypeArray("DI");
            setSaleType("DI");
            localStorage.setItem("dineIn", "Y");
          } else if (posConfig?.enableTakeAway === "Y" && posConfig?.enableDineIn === "N") {
            selectedSaleTypeArray = await getSaleTypeArray("TA");
            setSaleType("TA");
            localStorage.setItem("dineIn", "N");
          } else {
            setSaleType("DE");
            localStorage.setItem("dineIn", "N");
          }
        }
        if (selectedSaleTypeArray) {
          handleSelectedSaleTypeForProducts(selectedSaleTypeArray)();
        }
      } catch (error) {
        console.error("Error fetching or handling sale type:", error);
      }
    };

    const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
    if (cartDetails?.preOrder !== "Y") {
      fetchAndHandleSaleType();
    }
  }, []);

  // useEffect(() => {
  //   if (keyValue === "0" && posConfig?.enableTakeAway === "Y") {
  //     localStorage.setItem("dineIn", "N");
  //   }
  // }, [keyValue]);

  const getSaleTypeArray = async (type) => {
    try {
      const saleTypes = await db.posSaletypes.toArray();
      const selectedSaleTypeArray = saleTypes.filter((saleType) => saleType.cwrSaletype.fulfilmentType === type);
      return selectedSaleTypeArray.length > 0 ? selectedSaleTypeArray[0] : null;
    } catch (error) {
      console.error("Error fetching sale types:", error);
      return [];
    }
  };

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long", // Full day name (e.g., Wednesday)
    day: "numeric", // Day of the month (e.g., 28)
    month: "long", // Full month name (e.g., June)
    year: "numeric", // Full year (e.g., 2023)
  })}`;

  let cleanToken;
  const authHeaders = getOAuthHeaders();
  if (authHeaders) {
    cleanToken = authHeaders.access_token;
  }

  const handleKeyvalue = (value, fulfilmentType) => {
    setKeyValue(value);
    localStorage.setItem("dineIn", fulfilmentType === "DI" ? "Y" : "N");
    if (value === "0") {
      // history.push("/table-management");
    } else if (value === "2") {
      // let newCart = createNewCart(tillData);
      // setCart(newCart);
      localStorage.setItem("homeDelivery", "N");
    }
    // localStorage.setItem("dineIn", "Y");

    if (value !== "2") {
      localStorage.setItem("homeDelivery", "Y");
    }
  };

  useEffect(async () => {
    await db.products
      .filter((product) => product.isactive === true)
      .toArray()
      .then((productsFetched) => {
        setProductsList([...productsFetched.slice(0, 50)]);
      });
    return () => {
      // socket.off("orderReceived", handleOrderReceived);
    };
  }, []);

  const getCustomerData = async (values) => {
    // 🔥 Use guestMobile stored from handleGuestCustomerSearch
    const mobileNumber = guestMobile;

    // 🆕 CREATE NEW CUSTOMER IF NOT FOUND
    if (isNewGuestCustomer) {
      const newCust = {
        name: values.guestName || "",
        mobile: mobileNumber, // 🔥 FIXED HERE
        email: "",
        pincode: "",
        city: "",
        street: "",
        lastName: "",
      };

      await addNewCustomer(newCust);

      // Update cart
      // const updatedCart = {
      //   ...cart,
      //   customer: {
      //     name: newCust.name,
      //     mobileNo: newCust.mobile,
      //   },
      // };

      // setCart(updatedCart);
      // localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    }

    // ---------------- EXISTING LOGIC CONTINUES ----------------

    setGuestsModalFlag(false);
    setNumberOfPersons("");
    localStorage.setItem("dineIn", "Y");

    let tabledata = [];
    let updatedTable = null;
    await db.tableData.toArray().then((fetched) => {
      fetched.map((item) => {
        if (item.cwrFbTableId === recordState.cwrFbTableId) {
          item.noOfPersons = values?.noOfGuests ?? 0;
          item.waiter = values?.waiterId ?? "";
          item.salesRepId = values?.waiterId ?? "";
          item.referredBy = values?.referredBy ?? "";
          item.guestName = values?.guestName ?? "";
          item.tableSync = "N";
          item.statusType = "STD";
          item.fbtableStatusId = item.fbtableStatusId ?? uuidv4().replace(/-/g, "").toUpperCase();
          item.guestType = priorityBtn ? "single" : "family";
          item.salesRepId = tillData.tillAccess.salesRepId;
          item.uniqueId = uuidv4().replace(/-/g, "").toUpperCase();
          item.color = "#978ea1";
          item.ordered = "N";
          item.items = [];
          item.startedAt = moment().format("YYYY-MM-DD HH:mm");
          updatedTable = { ...item };
        }
        tabledata.push(item);
      });
    });

    await db.tableData.clear();
    await db.tableData.bulkPut(tabledata);

    if (updatedTable) {
      await SyncData(updatedTable, "upsertTableStatus");
    }

    localStorage.setItem("locatedList", JSON.stringify(tabledata));
    localStorage.setItem("tableName", JSON.stringify(recordState));

    setSelectedTable(recordState);
    setTableCards(tabledata);
    setMainTableData(tabledata);
    setOcupiedTablesData(tabledata.filter((table) => table.statusType === "OCU" || table.statusType === "ONG"));
    setShowProducts(true);

    if (posConfig?.enableGuestRegistration !== "Y") {
      handleDisplayOk(recordState);
    }
  };

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        if (!selectedTable) return;
        let newCart = cart;
        const tableData = await db.tableData.where("cwrFbTableId").equals(selectedTable?.cwrFbTableId).toArray();
        if (tableData.length > 0) {
          if ((tableData[0].ordered === "N" || !tableData[0].ordered) && tableData[0].statusType !== "ONG" && tableData[0].statusType !== "STD") {
            await handleNewOrder(tableData[0], newCart, userPreferences);
          } else {
            await handleExistingOrder(selectedTable);
          }
          await cleanupCompletedOrders();
        }
      } catch (error) {
        console.error("Error in useOrderManagement:", error);
      }
    };

    fetchTableData();
  }, [orderCanceled, selectedTable]);

  const handleNewOrder = async (tableData, newCart, userPreferences) => {
    let allTableData = await db.tableData.toArray();
    const updatedResponse = {
      ...tableData,
      fbOrderId: uuidv4().replace(/-/g, "").toUpperCase(),
      lines: [],
      items: [],
      ordered: "Y",
      fbOrderSync: "N",
      fbOrderStatus: "IP",
      dineIn: localStorage.getItem("dineIn"),
      createdTime: moment(new Date()).format(userPreferences.dateTimeFormat),
      cart: newCart,
      splitTable: tableData?.splitTable || null,
    };

    const updatedTableData = allTableData.map((item) => {
      if (item.cwrFbTableId === tableData.cwrFbTableId) {
        item.ordered = "Y";
        item.documentno = newCart.documentno;
        item.statusType = tableData.statusType || "OCU";
        item.color = "#a7c957";
      }
      return item;
    });
    await db.fbOrderData.add(updatedResponse);
    await db.tableData.clear();
    await db.tableData.bulkPut(updatedTableData);

    await SyncData(updatedResponse, "upsertTableStatus");
    setCart(updatedResponse.cart || newCart);
  };

  const parseCreatedTime = (timeStr) => {
    // "29-09-2025 16:31:11"
    const [datePart, timePart] = timeStr.split(" ");
    const [day, month, year] = datePart.split("-");
    return new Date(`${year}-${month}-${day}T${timePart}`);
  };

  const handleExistingOrder = async (selectedTable) => {
    const tableRecord = await db.tableData.get(selectedTable?.cwrFbTableId);
    if (selectedTable?.splitTable) {
      console.log("⛔ handleExistingOrder skipped for split table:", selectedTable.splitTable);
      return;
    }
    // const orders = await db.fbOrderData.where("cwrFbTableId").equals(selectedTable?.cwrFbTableId).toArray();
    // const orders = await db.fbOrderData
    //   .filter((o) => (o.cwrFbTableId === selectedTable?.cwrFbTableId || o.fbTableId === selectedTable?.cwrFbTableId) && o.fbOrderStatus !== "CL")
    //   .toArray();

    const orders = await db.fbOrderData.where("cwrFbTableId").equals(tableRecord.cwrFbTableId).toArray();
    const ordersData = orders.find((order) => order.fbOrderStatus === "IP");
    const ordersFetched = ordersData ? [ordersData] : [];
    // const ordersFetched = orders.sort((a, b) => parseCreatedTime(b.createdTime) - parseCreatedTime(a.createdTime));
    // const ordersFetched = orders.sort((a, b) => {
    //   const aTime = a.createdTime ? parseCreatedTime(a.createdTime) : 0;
    //   const bTime = b.createdTime ? parseCreatedTime(b.createdTime) : 0;
    //   return bTime - aTime;
    // });
    if (ordersFetched.length > 0) {
      ordersFetched.forEach((fbOrder) => {
        if (fbOrder?.wsData && typeof fbOrder?.wsData === "object" && Object.keys(fbOrder?.wsData).length > 0 && fbOrder?.fbOrderStatus === "IP") {
          if (fbOrder?.wsData?.items?.length > 0) {
            const total = fbOrder?.wsData?.items.reduce((sum, item) => (item.isCanceled === "Y" ? sum : sum + (Number(item.nettotal) || 0)), 0);

            const tax = fbOrder?.wsData?.items.reduce((sum, item) => (item.isCanceled === "Y" ? sum : sum + (Number(item.taxAmount) || 0)), 0);
            const preciseTotal = parseFloat(cart?.total?.toFixed(precision));
            let cartData = {
              ...fbOrder.wsData,
              tableNo: selectedTable?.name,
              items: fbOrder.wsData.items?.map((line) => ({
                ...line,
                sendQty: line.order === "Y" ? 0 : 1,
                parkedItem: true,
              })),
              total: parseFloat(total.toFixed(precision)),
              tax: parseFloat(tax.toFixed(precision)),
              subTotal: parseFloat(parseFloat(total.toFixed(precision)) - parseFloat(tax.toFixed(precision))),
              totalStd: cart?.items?.reduce((sum, item) => (item?.isCanceled === "Y" ? sum : sum + (item?.linestd || 0)), 0) || 0,
              amountInWords: numberToWords(preciseTotal),
            };
            setCart(cartData);
            localStorage.setItem("cartObj", JSON.stringify(cartData));
          }
        } else if (fbOrder?.wsData && typeof fbOrder?.wsData === "object" && Object.keys(fbOrder?.wsData).length === 0) {
          let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
          let cartData = {
            ...cartObj,
            items: [],
          };
          setCart(cartData);
          localStorage.setItem("cartObj", JSON.stringify(cartData));
        } else {
          if (fbOrder.fbOrderStatus === "IP") {
            const total = fbOrder.cart.items.reduce((sum, item) => (item.isCanceled === "Y" ? sum : sum + (Number(item.nettotal) || 0)), 0);

            const tax = fbOrder.cart.items.reduce((sum, item) => (item.isCanceled === "Y" ? sum : sum + (Number(item.taxAmount) || 0)), 0);
            let cartData = {
              ...fbOrder.cart,
              discount: fbOrder.cart.discount || 0,
              orderTime: fbOrder.creatdeTime,
              tableNo: fbOrder.name,
              statusType: "OCU",
              sOrderID: fbOrder?.cart?.sOrderID || uuidv4().replace(/-/g, "").toUpperCase(),
              items: fbOrder.cart.items.map((item) => ({
                ...item,
                sendQty: 0,
              })),
              total: parseFloat(total.toFixed(precision)),
              tax: parseFloat(tax.toFixed(precision)),
            };
            setCart(cartData);
            localStorage.setItem("cartObj", JSON.stringify(cartData));
          }
        }
      });
    }
  };

  const cleanupCompletedOrders = async () => {
    await db.fbOrderData
      .where("fbOrderStatus")
      .equals("CO")
      .and((order) => order.fbOrderSync === "Y")
      .delete();
  };

  // const [displayAddOnSelection, setDisplayAddOnSelection] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [addOnsList, setAddOnsList] = useState({
    requiredList: [],
    optionsList: [],
  });
  const [selectedAddons, setSelectedAddons] = useState([]);

  const generateWaitlistId = () => "WL-" + Date.now();

  const saveToWaitlist = async (guestData = null) => {
    if (!guestData && !validateWaitlistForm()) return;

    let customerId = null;

    // OVERRIDE FORM VALUES WHEN SEAT GUEST OR DELETE
    if (guestData) {
      waitlistForm.waitlistId = guestData.waitlistId;
      waitlistForm.status = guestData.status; // STD or CL

      // 🔥 Correct fields from UI waitlist entry:
      waitlistForm.name = guestData.name || waitlistForm.name || "";
      waitlistForm.phone = guestData.phone || waitlistForm.phone || "";
      waitlistForm.guests = guestData.guests || waitlistForm.guests || 0;
      waitlistForm.eta = guestData.eta || waitlistForm.eta || 0;
    }

    // ------------------------------------------
    // 1) CHECK EXISTING CUSTOMER BY PHONE
    // ------------------------------------------
    if (waitlistForm.phone && waitlistForm.phone.length === 10) {
      const response = await getCustomer(null, 2, waitlistForm.phone, null, () => {}, null, tillData);

      const list = response?.data?.data?.customerSearch || [];

      const match = list.find((x) => x.mobileNo?.toString() === waitlistForm.phone.toString());

      if (match) {
        // ✔ Existing customer found
        customerId = match.cwrCustomerId;
      } else {
        // ------------------------------------------
        // 2) NEW CUSTOMER → USE addNewCustomer()
        // ------------------------------------------
        const newCust = {
          name: waitlistForm.name || "",
          mobile: waitlistForm.phone,
          email: "",
          pincode: "",
          city: "",
          street: "",
          lastName: "",
        };

        await addNewCustomer(newCust);

        setCart((prev) => ({
          ...prev,
          customer: {
            cwrCustomerId: null,
            name: newCust.name,
            mobileNo: newCust.mobile,
          },
        }));

        localStorage.setItem(
          "cartObj",
          JSON.stringify({
            ...cart,
            customer: {
              cwrCustomerId: null,
              name: newCust.name,
              mobileNo: newCust.mobile,
            },
          })
        );

        customerId = null;
      }
    }

    // ------------------------------------------
    // 2) SUPPORT UPDATED STATUS LOGIC
    //    - NEW waitlist → "WAT"
    //    - DELETE → "CL"
    //    - SEAT GUEST → "STD"
    // ------------------------------------------

    const statusSource = guestData?.status || waitlistForm.status;

    const finalStatus = statusSource === "CL" ? "CL" : statusSource === "STD" ? "STD" : "WAT";

    // ------------------------------------------
    // 3) PREPARE WAITLIST PAYLOAD
    // ------------------------------------------
    const payload = {
      waitlistId: waitlistForm.waitlistId || generateWaitlistId(),
      bunitId: tillData.tillAccess.csBunit.csBunitId,
      guestName: waitlistForm.name,
      mobileNo: waitlistForm.phone,
      noOfGuests: waitlistForm.guests,
      estimateWaitTime: waitlistForm.eta,
      status: finalStatus, // <--- UPDATED
      b2cCustomerId: cart.customer?.cwrCustomerId || null,
    };

    // SAVE / UPDATE / DELETE
    const res = await upsertWaitlist(payload);

    if (res?.status === "200") {
      const fresh = await loadWaitlistForUI();
      setWaitlistList(fresh);

      // Reset form only if adding OR modifying, not on seat/delete
      if (finalStatus === "WAT") {
        setWaitlistForm({ name: "", phone: "", guests: "", eta: "" });
        setWaitlistErrors({});
        setWaitlistTab("current");
        setWaitlistDrawerOpen(false);
      }
    }
  };

  const loadWaitlistForUI = async () => {
    try {
      const rawList = await getWaitlist("0", "50");

      return rawList.map((item, index) => ({
        id: item.waitlistId ?? index + 1,
        name: item.guestName || "",
        phone: item.mobileNo || "",
        guests: item.noOfGuests || "",
        eta: item.estimateWaitTime || "",
        cwrCustomerId: item.b2cCustomerId || item.b2c_customer_id || item.cwrCustomerId || null,
        status: item.status,
        created: item.created,
        notified: false,
      }));
    } catch (err) {
      console.error("Error formatting UI waitlist:", err);
      return [];
    }
  };

  const validateWaitlistForm = () => {
    let err = {};

    if (!waitlistForm.name.trim()) err.name = "Please enter guest name";
    if (!waitlistForm.phone.trim()) err.phone = "Please enter phone number";
    if (!waitlistForm.guests) err.guests = "Please select guest size";
    if (!waitlistForm.eta.trim()) err.eta = "Please enter estimated wait time";

    setWaitlistErrors(err);
    return Object.keys(err).length === 0;
  };

  const validateForm = () => {
    let newErrors = {};

    if (!reserveTableForm.getFieldValue("name")?.trim()) newErrors.guestName = "Please enter guest name";

    if (!reservePhone.trim()) newErrors.phone = "Please enter phone number";

    if (!reserveTableForm.getFieldValue("time")) newErrors.resTime = "Please select reservation time";

    if (!noOfPersons) newErrors.guestCount = "Please select number of guests";

    if (!reserveTableForm.getFieldValue("tableNum")) newErrors.tableNum = "Please select table";

    if (!reserveTableForm.getFieldValue("section")) newErrors.section = "Please select section";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const loadReservations = async () => {
    const selectedDate = moment().format("YYYY-MM-DD");
    let allReservations = [];

    // ⭐ 1) Reservations WITHOUT tableId
    const listNoTable = await getTableReservation(null, selectedDate);
    if (Array.isArray(listNoTable)) {
      allReservations.push(...listNoTable);
    }

    // ⭐ 2) Reservations BY TABLE
    // for (const tbl of tableList) {
    //   const list = await getTableReservation(tbl.cwrFbTableId, selectedDate);
    //   if (Array.isArray(list)) {
    //     allReservations.push(...list);
    //   }
    // }

    // ⭐ 3) REMOVE DUPLICATES BY RESERVATION ID
    const uniqueReservations = Array.from(new Map(allReservations.map((r) => [r.fbTableReservationId, r])).values());

    console.log("🟢 Unique reservations:", uniqueReservations);

    // ⭐ 4) MAP CLEAN DATA
    const mapped = uniqueReservations.map((r) => {
      const timeRaw = r.resTime || r.reservationTime;
      const dateRaw = r.resDate || r.reservationDate;
      const statusKey = r.status ? r.status.toUpperCase() : "NEW";

      return {
        id: r.fbTableReservationId,
        tableId: r.fbTableId,
        sectionId: r.fbSectionId,
        name: r.customerName,
        phone: r.contactNo || "",
        guests: r.noOfPeople,
        date: moment(dateRaw).format("DD/MM/YYYY"),
        time: moment(timeRaw).format("DD/MM/YYYY, hh:mm A"),
        status: statusKey,
        statusLabel: statusKey === "NEW" ? "Upcoming" : statusKey === "CK" ? "Checked In" : statusKey === "NS" ? "No Show" : statusKey,
        tableName: r.created,
        section: r.guestType,
      };
    });

    setReservationList(mapped);
    console.log("Loaded Reservations:", mapped);
  };

  // useEffect(() => {
  //   const run = async () => {
  //     const till = JSON.parse(localStorage.getItem("tillData"));

  //     const access = till?.tillAccess?.userAccessController ? JSON.parse(till.tillAccess.userAccessController) : null;

  //     // load only when dineIn = Y
  //     if (access?.dineIn === "Y" && tableList.length > 0) {
  //       await loadReservations(); // <-- async call
  //     }
  //   };

  //   run();
  // }, [tableList]); // must wait for tableList to load

  const handleAddOnModal = (record, event) => {
    event.stopPropagation();
    setDisplayAddOnSelection(true);
    setSelectedProduct(record);
    const requiredListFilter = _.filter([...record.productAddons], (item) => item.mAddonGroup.minqty === 1);
    const optionsListFilter = _.filter([...record.productAddons], (item) => item.mAddonGroup.minqty === 0);
    setAddOnsList({
      requiredList: requiredListFilter || [],
      optionsList: optionsListFilter || [],
    });
  };

  const handleAddOnValue = (e, fieldName) => {
    let newSelectedAddons = [...selectedAddons];
    const indexValue =
      fieldName === "addOnRadio"
        ? _.findIndex(newSelectedAddons, (item) => item.mAddonGroup.mAddonGroupId === e.target.value.mAddonGroup.mAddonGroupId)
        : _.findIndex(newSelectedAddons, (item) => item === e.target.value);
    if (indexValue !== -1) {
      if (e.target.checked) {
        newSelectedAddons[indexValue] = e.target.value;
      } else {
        newSelectedAddons.splice(indexValue, 1);
      }
    } else {
      newSelectedAddons = [...selectedAddons, e.target.value];
    }
    setSelectedAddons(newSelectedAddons);
  };

  const handleQty = (fieldName) => {
    let newSelectedProduct = {
      ...selectedProduct,
      weight: selectedProduct?.weight || 1,
    };
    if (fieldName === "plus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) + 1;
    }
    if (fieldName === "minus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) - 1;
      if (newSelectedProduct.weight <= 1) {
        newSelectedProduct.weight = 1;
      }
    }

    setSelectedProduct({
      ...newSelectedProduct,
    });
  };

  const handleAdd = async () => {
    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        productAddons: selectedAddons || [],
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice,
      false
    );
    handleAddOnModalClose();
  };

  const handleAddOnModalClose = () => {
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const manualDiscountRestaurant = async (values) => {
    if (selectedProductInCart) {
      const pr = await db.pricingRules.toArray();
      const index = pr.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId && md.manualDiscount === "Y");
      if (index !== -1) {
        const pricingRule = pr[index];
        if (pricingRule.type !== "TD") {
          let discountValue =
            pricingRule.discountType === "V"
              ? selectedProductInCart.discount
              : ((selectedProductInCart.discount / (selectedProductInCart?.realPrice * selectedProductInCart?.weight)) * 100).toFixed(2);
          manualDiscountForm.setFieldsValue({
            discountName: pricingRule.mPricingrulesId,
            discountValue: discountValue,
          });
          setManualDiscountInput(discountValue);
          setSelectedManualDiscountTypeValue(pricingRule);
        } else {
          const matchedPricingRule = cart?.manualDiscountData?.totalLevelDiscount?.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
          manualDiscountForm.setFieldsValue({
            discountName: pricingRule.mPricingrulesId,
            discountValue: cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue,
          });
          setManualDiscountInput(cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue);
          setSelectedManualDiscountTypeValue(pricingRule);
        }
      } else {
        manualDiscountForm.resetFields();
        setManualDiscountInput("");
        setSelectedManualDiscountTypeValue("");
      }
    }
    parseInt(cart.total) > 0 && setManualDiscountModalVisible(true);
  };

  const handleCancelOrder = async () => {
    await db.tableData
      .where("cwrFbTableId")
      .equals(selectedTable.cwrFbTableId)
      .toArray()
      .then(async (response) => {
        if (response.length > 0) {
          response[0].status = "OPN";
          response[0].salesRepId = response[0].waiter;
          response[0].lines = [];
          response[0].color = "rgba(146, 144, 152, 0.5)";
          response[0].statusType = "OPN";
          response[0].fbOrderSync = "N";
          response[0].tableSync = "N";
          await db.tableData.update(response[0].cwrFbTableId, response[0]);
          SyncData(response[0], "upsertTableStatus");
          await db.fbOrderData
            .where("cwrFbTableId")
            .equals(selectedTable?.cwrFbTableId)
            .toArray()
            .then((ordersFetched) => {
              if (ordersFetched.length > 0) {
                ordersFetched.map(async (fbOrder) => {
                  if (fbOrder.fbOrderStatus === "IP") {
                    db.fbOrderData.where("fbOrderId").equals(fbOrder.fbOrderId).modify({ fbOrderSync: "N", fbOrderStatus: "CL" });
                    SyncData(fbOrder, "upsertFbOrder");
                  }
                });
              }
            });
          // history.push("/table-management");
          history.push("/pos");
        }
      });
  };

  const handleOrder = (fireItems = []) => {
    console.log("HANDLE ORDER CALLED - fireItems:", fireItems);

    let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
    // 1. Clone current cart
    const currentCart = structuredClone(cartObj);
    const previousItems = structuredClone(cartObj.items);

    // 2. Process items
    const processedItems = currentCart.items.map((item) => {
      const oldItem = previousItems.find((i) => i.lineId === item.lineId);
      const oldFired = Number(oldItem?.firedQty || 0);
      const currentQty = Number(item.weight || 0);

      console.log(`Item: ${item.name} | item.lineId} → oldFired: ${oldFired}, current: ${currentQty}`);

      if (currentQty > oldFired) {
        const qtyToSend = currentQty - oldFired;
        console.log(`→ WILL FIRE +${qtyToSend}`);

        return {
          ...item,
          order: "N",
          sendQty: qtyToSend, // ← modal reads this
          firedQty: currentQty, // ← remember total fired
          saleType: item.saleType || "DI",
        };
      }
      return item;
    });

    // 3. Get only items that need to be fired
    // let itemsToShow = processedItems.filter((item) => item.order === "N" && item.sendQty > 0);

    // 3. Get only items that need to be fired (excluding held items)
    let itemsToShow = processedItems.filter((item) => item.order === "N" && item.sendQty > 0 && !item.isHold);

    // 4. If single fire, filter by passed items
    if (fireItems.length > 0) {
      const ids = fireItems.map((i) => i.lineId);
      itemsToShow = itemsToShow.filter((item) => ids.includes(item.lineId));
    }

    // 5. If nothing to show → don't open modal
    if (itemsToShow.length === 0) {
      console.log("Nothing to fire");
      message.info("No new items or quantity to send to kitchen");
      return;
    }

    // 6. Update state
    setOederedData(itemsToShow);
    setPendingFireItems(itemsToShow);
    setCart({
      ...cart,
      items: processedItems, // ← save firedQty permanently
    });
    setSelectedItemsModalOpen(true);
  };

  const handleTable = async (record) => {
    const tableRecord = await db.tableData.get(record?.cwrFbTableId);

    if (!tableRecord) {
      console.log("undefined 'tableRecord'");
      return;
    }

    let selectedTableRecord = tableRecord;
    const splitIdentifier = record?.splitTable;
    if (splitIdentifier && tableRecord?.splitTables) {
      const splitInfo = tableRecord.splitTables.find((s) => s.splitTable === splitIdentifier);

      if (splitInfo) {
        // Create a virtual table object for this split
        selectedTableRecord = {
          ...tableRecord,
          displayName: splitIdentifier,
          tableName: splitIdentifier,
          name: splitIdentifier,
          splitTable: splitIdentifier,
          statusType: splitInfo.status,
          guests: splitInfo.guests,
          noOfPersons: splitInfo.guests,
          guestName: splitInfo.guestName || "",
          guestType: splitInfo.guestType || "",
          salesRepId: splitInfo.salesRepId || tableRecord.salesRepId,
        };

        console.log("[v0] Selected split table:", selectedTableRecord);
      }
    }

    // Common flow for both split and regular tables
    guestForm.resetFields();
    setGuestMobile("");
    setInputFields({});
    setPriorityBtn(false);

    // setCart(clearCartData)
    // localStorage.setItem("cartObj", JSON.stringify(clearCartData))

    guestForm.resetFields();
    setRecardState(selectedTableRecord);

    const ordersFetched = await db.fbOrderData.where("cwrFbTableId").equals(tableRecord.cwrFbTableId).toArray();

    let activeOrder = null;
    if (selectedTableRecord.splitTable) {
      activeOrder = ordersFetched.find((o) => o.fbOrderStatus === "IP" && o.splitTable === selectedTableRecord.splitTable);
      console.log("[v0] Active order for split:", activeOrder, "splitTable:", selectedTableRecord.splitTable);
    } else {
      // For regular tables, find any active order
      activeOrder = ordersFetched.find((o) => o.fbOrderStatus === "IP");
    }

    setCart((prev) => {
      let updatedCart = {
        ...clearCartData, // Start with clear cart structure
        customer: {
          name: selectedTableRecord.guestName || "",
          mobileNo: selectedTableRecord.mobile || "",
        },
        splitTable: selectedTableRecord.splitTable || null,
        tableId: selectedTableRecord.cwrFbTableId,
        tableName: selectedTableRecord.tableName,
      };
      if (record?.splitTable && Array.isArray(tableRecord.splitTables)) {
        const matchedSplit = tableRecord.splitTables.find((s) => s.splitTable === record.splitTable);

        if (matchedSplit?.cart) {
          console.log("[v0] Loading FULL split cart for:", record.splitTable);
          const total = matchedSplit.cart.items.reduce((sum, item) => (item.isCanceled === "Y" ? sum : sum + (Number(item.nettotal) || 0)), 0);

          const tax = matchedSplit.cart.items.reduce((sum, item) => (item.isCanceled === "Y" ? sum : sum + (Number(item.taxAmount) || 0)), 0);
          const preciseTotal = parseFloat(cart?.total?.toFixed(precision));
          updatedCart = {
            ...matchedSplit.cart,
            items: matchedSplit.cart.items.map((item) => {
              const fired = Number(item.firedQty || 0);
              const qty = Number(item.weight || 0);

              return {
                ...item,
                sendQty: Math.max(qty - fired, 0),
                parkedItem: true,
                splitTable: record.splitTable,
              }; // 🔥 FULL CART
            }),
            tableNo: tableRecord.name, // Parent table name
            tableId: tableRecord.cwrFbTableId,
            tableName: record.splitTable, // Split table name
            splitTable: record.splitTable,
            total: parseFloat(total.toFixed(precision)),
            tax: parseFloat(tax.toFixed(precision)),
            subTotal: parseFloat(parseFloat(total.toFixed(precision)) - parseFloat(tax.toFixed(precision))),
            totalStd: cart?.items?.reduce((sum, item) => (item?.isCanceled === "Y" ? sum : sum + (item?.linestd || 0)), 0) || 0,
            amountInWords: numberToWords(preciseTotal),
          };

          localStorage.setItem("cartObj", JSON.stringify(updatedCart));
          return updatedCart; // ⛔ HARD STOP (important)
        }
      }
      if (tableRecord?.wsData && typeof tableRecord?.wsData === "object" && Object.keys(tableRecord?.wsData).length > 0) {
        console.log("[v0] Loading cart from wsData");
        let wsItems = tableRecord.wsData.items || [];

        if (selectedTableRecord.splitTable) {
          wsItems = wsItems.filter((item) => item.splitTable === selectedTableRecord.splitTable);
        }

        updatedCart = {
          ...tableRecord.wsData,
          tableNo: tableRecord?.name,
          splitTable: selectedTableRecord.splitTable || null,
          items: wsItems.map((line) => ({
            ...line,
            sendQty: line.order === "Y" ? 0 : 1,
            parkedItem: true,
            splitTable: selectedTableRecord.splitTable || line.splitTable || null, // Ensure splitTable is set
          })),
        };
      } else if (tableRecord?.wsData && typeof tableRecord?.wsData === "object" && Object.keys(tableRecord?.wsData).length === 0) {
        console.log("[v0] wsData is empty object");
        updatedCart = {
          ...updatedCart,
          items: [],
        };
      } else if (activeOrder && activeOrder.cart) {
        console.log("[v0] Loading cart from activeOrder.cart, order:", activeOrder.fbOrderId);
        const cartItems = activeOrder.cart.items || [];

        // Items are already associated with the split via the order's splitTable field
        // Don't filter by item.splitTable as items might not have this field initially

        updatedCart = {
          ...activeOrder.cart,
          tableNo: selectedTableRecord?.name || selectedTableRecord?.tableName,
          splitTable: selectedTableRecord.splitTable || null,
          items: cartItems.map((line) => ({
            ...line,
            sendQty: line.order === "Y" ? 0 : 1, // Keep sendQty: 0 for fired items so they show
            parkedItem: true,
            splitTable: selectedTableRecord.splitTable || line.splitTable || null, // Ensure splitTable is set
          })),
        };

        console.log("[v0] Loaded cart items:", updatedCart.items.length, "fired items:", updatedCart.items.filter((i) => i.order === "Y").length);
      } else {
        console.log("[v0] No existing order or wsData - empty cart");
      }

      localStorage.setItem("cartObj", JSON.stringify(updatedCart));

      return updatedCart;
    });

    const array = [];
    await db.tableData
      .where("cwrFbTableId")
      .equals(tableRecord.cwrFbTableId)
      .toArray()
      .then(async (response) => {
        if (response.length > 0) {
          const orderedData = [];
          const cancelData = [];
          const cancelItems = [];
          const table = [...response];

          const cartItems = activeOrder?.cart?.items || table[0]?.cart?.items || [];

          cartItems.forEach((x) => {
            // But only if the item has a splitTable field set
            if (selectedTableRecord.splitTable && x.splitTable && x.splitTable !== selectedTableRecord.splitTable) {
              return;
            }

            if (x.update === "N") {
              orderedData.push(x);
            }
            if (x.isCanceled === "Y") {
              cancelData.push(x);
              cancelItems.push(`{
                    fbOrderLineId:"${x.fbOrderLineId}"
                      isCanceled: "Y"
                  }`);
            }
          });

          if (cancelItems.length > 0) {
            const obj = {
              fbOrderId: activeOrder?.fbOrderId || table[0].fbOrderId || table[0].cart.fbOrderId,
              cancelItems: cancelItems,
            };
            SyncData(obj, "cancelItem");
          }

          setOederedData(orderedData);

          array.push(...response);

          if (selectedTableRecord?.statusType === "OPN" || selectedTableRecord?.statusType === "AVL") {
            if (inputRef.current) {
              inputRef.current.focus();
            }
            if (posConfig?.enableGuestRegistration === "Y") {
              setGuestsModalFlag(true);
            } else {
              setShowProducts(true);
            }
            setSelectedTable(selectedTableRecord);
          } else {
            selectedTableRecord.noOfPersons = selectedTableRecord.noOfPersons || array[0].noOfPersons;
            selectedTableRecord.waiter = array[0].waiter;
            selectedTableRecord.guestName = selectedTableRecord.guestName || array[0].guestName;
            selectedTableRecord.guestType = selectedTableRecord.guestType || array[0].guestType;
            selectedTableRecord.fbOrderId = activeOrder?.fbOrderId || array[0].fbOrderId;
            selectedTableRecord.items = orderedData;
            selectedTableRecord.fbtableStatusId = array[0].fbtableStatusId === undefined ? uuidv4().replace(/-/g, "").toUpperCase() : array[0].fbtableStatusId;

            localStorage.setItem("tableName", JSON.stringify(selectedTableRecord));
            setSelectedTable(selectedTableRecord);
            setShowProducts(true);

            setTableCards((prevTableCards) =>
              prevTableCards?.map((tableCard) => (tableCard.cwrFbTableId === tableRecord.cwrFbTableId ? { ...tableCard, ...tableRecord } : tableCard))
            );
          }
        }
      });
  };

  function getDailyGlobalTokenKey() {
    const today = new Date().toISOString().split("T")[0];
    return `global_daily_kot_token_counter_${today}`;
  }

  const handleDisplayOk = async (recordState, itemsToFire = []) => {
    setSelectedItemsModalOpen(false);
    setShowSendToKitchen(false);

    let uniqId = uuidv4().replace(/-/g, "").toUpperCase();

    if (recordState) {
      recordState.uniqId = uniqId;
    }

    localStorage.setItem("tableName", JSON.stringify(recordState));

    let newCart = {
      ...cart,
      tableNo: recordState?.table,
    };

    newCart?.items?.forEach((cartItem) => {
      cartItem.parkedItem = true;
    });

    const pcTokenMap = {};

    // Global daily counter
    const tokenKey = getDailyGlobalTokenKey();
    let currentTokenCounter = Number(localStorage.getItem(tokenKey)) || 0;

    const fireableLineIds = new Set((itemsToFire.length > 0 ? itemsToFire : pendingFireItems).map((i) => i.lineId));

    const finalizedItems = newCart.items.map((cartItem) => {
      if (cartItem.isHold) return cartItem;

      const shouldFire = fireableLineIds.has(cartItem.lineId);
      if (!shouldFire) return cartItem;

      const pcId = cartItem.productionCenterId;
      let kotTokenId = cartItem.kotTokenId;
      let kotTokenNo = cartItem.kotTokenNo; // ← changed field name

      // Original kotTokenId logic (unchanged)
      if (!kotTokenId && pcId) {
        if (!pcTokenMap[pcId]) {
          pcTokenMap[pcId] = uuidv4().replace(/-/g, "").toUpperCase();
        }
        kotTokenId = pcTokenMap[pcId];
      }

      // kotTokenNo logic: increment + add "T-" prefix
      if (shouldFire) {
        currentTokenCounter += 1;
        kotTokenNo = `T-${currentTokenCounter}`; // ← T-1, T-2, T-3...
      }

      return {
        ...cartItem,
        order: "Y",
        update: "N",
        orderStatus: "OR",
        ...(kotTokenId ? { kotTokenId } : {}),
        ...(kotTokenNo ? { kotTokenNo } : {}), // ← new field name
      };
    });

    // Save updated counter
    if (currentTokenCounter > 0) {
      localStorage.setItem(tokenKey, String(currentTokenCounter));
    }

    const allItemsFired = finalizedItems.every((item) => item.isHold || item.order === "Y");
    let orderLines = [];
    if (recordState?.cwrFbTableId) {
      const existingFbOrder = await db.fbOrderData
        .where("cwrFbTableId")
        .equals(recordState.cwrFbTableId)
        .filter((order) => order.fbOrderStatus === "IP")
        .first();
      let fbOrder;
      let fbOrderId;
      if (existingFbOrder) {
        fbOrder = existingFbOrder;
        fbOrderId = existingFbOrder.fbOrderId;
      } else {
        const fbOrders = JSON.parse(localStorage.getItem("getFBOrderData") || "[]");
        const filteredOrders = Array.isArray(fbOrders) ? fbOrders.filter((o) => o.fbTableId === recordState?.cwrFbTableId || o.fbTableId === recordState?.fbTableId) : [];
        const fbOrderDataID = filteredOrders[0]?.fbOrderId;
        fbOrderId = fbOrderDataID || uuidv4().replace(/-/g, "").toUpperCase();
        fbOrder = {
          fbOrderId,
          cwrFbTableId: recordState?.cwrFbTableId,
          fbOrderStatus: "IP",
          lines: [],
          fbOrderSync: "N",
          cart: newCart,
          name: recordState?.table,
          noOfPersons: recordState?.noOfPersons,
          statusType: "OCU",
          dineIn: localStorage.getItem("dineIn"),
          uniqId: uniqId,
          splitTable: recordState?.splitTable || null,
        };
      }
      await db.tableData
        .where("cwrFbTableId")
        .equals(recordState?.cwrFbTableId)
        .modify((eventValue) => {
          // 🔥 SPLIT TABLE HANDLING
          if (recordState?.splitTable && Array.isArray(eventValue.splitTables)) {
            console.log("[v0] Updating split table items for:", recordState.splitTable);

            eventValue.splitTables = eventValue.splitTables.map((split) => {
              if (split.splitTable === recordState.splitTable) {
                return {
                  ...split,
                  status: "ONG",
                  cart: {
                    ...newCart,
                    items: finalizedItems.map((item) => ({
                      ...item,
                      splitTable: recordState.splitTable,
                    })),
                  },
                };
              }
              return split;
            });

            // 🚫 DO NOT store items at parent table level
            eventValue.items = [];
            eventValue.statusType = "ONG";
          } else {
            // 🔹 NORMAL (NON-SPLIT) TABLE
            // eventValue.items = newCart.items;
            eventValue.items = finalizedItems;
            eventValue.statusType = "ONG";
          }

          eventValue.totalAmount = newCart.total;
          eventValue.documentno = newCart.documentno;
          eventValue.time = moment(new Date()).format(userPreferences.dateTimeFormat);
          eventValue.tableSync = "N";
        });
      const isFireAll = fireMode === "all";
      const itemsForUpsert = finalizedItems.filter((i) => fireableLineIds.has(i.lineId) && !i.isHold);

      itemsForUpsert.forEach((item) => {
        let fbOrderLineId = uuidv4().replace(/-/g, "").toUpperCase();
        let fbMetaOrderId = uuidv4().replace(/-/g, "").toUpperCase();
        const lineId = item.lineId;
        const usedKeysLower = new Set([
          "productid",
          "mbatchid",
          "description",
          "uom",
          "tax",
          "discount",
          "weight",
          "unitprice",
          "listprice",
          "linegross",
          "lineid",
          "grossstd",
          "name",
          "value",
          "grossunit",
          "linestd",
          "netlist",
          "netstd",
          "netunit",
          "unittax",
          "order",
        ]);

        const metaFromItem = Object.fromEntries(Object.entries(item).filter(([key]) => !usedKeysLower.has(key.toLowerCase())));
        const metaString = {
          ...metaFromItem,
          lineId,
          fbMetaOrderId,
          fbOrderLineId,
          isSelected: "N",
          order: "Y",
        };

        item.fbOrderLineId = fbOrderLineId;
        orderLines.push({
          fbOrderId: `${fbOrderId}`,
          fbOrderLineId: `${fbOrderLineId}`,
          lineId: lineId,
          mPoductId: `${item.productId || item.mPoductId}`,
          mBatchId: item.mBatchId,
          description: `${item.description || ""}`,
          csUomId: `${item.uom}`,
          csTaxId: `${item.tax}`,
          discount: item.discount,
          line: 1,
          qty: item.weight,
          unitPrice: item.unitPrice,
          listPrice: item.listPrice,
          lineNet: item.linenet,
          lineTax: item.taxRate,
          lineGross: item.linegross,
          sOrderLineId: null,
          isOrdered: "Y",
          isCanceled: "N",
          grossStd: item.grossstd,
          grossUnit: item.grossunit,
          lineStd: item.linestd,
          netList: item.netList,
          netStd: item.netStd,
          netUnit: item.netunit,
          unitTax: item.unitTax,

          meta: [
            {
              key: "orderLine",
              value: JSON.stringify(metaString), // already JSON string
              fbOrderLineMetaId: `${fbMetaOrderId}`,
            },
          ],
        });
      });
      let array1 = [];

      for (let i = 0; i < cart.items.length; i++) {
        let item = cart.items[i];
        let printer = item.productionCenter;
        if (!array1.hasOwnProperty(`${printer}`)) {
          array1[`${printer}`] = [];
        }
        array1[`${printer}`].push(cart.items[i]);
      }
      setCart(newCart);
      const filteredCart = {
        ...newCart,
        items: (newCart.items || []).filter((item) => item?.order !== "Y" && !item.isHold),
      };
      newCart.items = finalizedItems.map((cartItem) => {
        // Skip held items - don't mark them as fired
        if (cartItem.isHold) {
          return cartItem;
        }

        if (itemsToFire.length === 0) {
          // FIRE ALL
          return { ...cartItem, order: "Y", update: "N" };
        }

        // FIRE SELECTED
        const isFired = itemsToFire.some((i) => i.lineId === cartItem.lineId);
        return isFired ? { ...cartItem, order: "Y", update: "N" } : cartItem;
      });

      // fbOrder.lines = [...(fbOrder?.lines ? fbOrder.lines : []), ...orderLines];
      fbOrder.lines = orderLines;
      fbOrder.fbOrderSync = "N";
      // fbOrder.cart = newCart;
      const preciseTotal = parseFloat(cart?.total?.toFixed(precision));
      newCart = {
        ...newCart,
        items: finalizedItems,
        totalStd: cart?.items?.reduce((sum, item) => (item?.isCanceled === "Y" ? sum : sum + (item?.linestd || 0)), 0) || 0,
        amountInWords: numberToWords(preciseTotal),
      };
      fbOrder.cart = newCart;
      setCart(newCart);
      localStorage.setItem("cartObj", JSON.stringify(newCart));
      if (recordState?.splitTable) {
        fbOrder.splitTable = recordState.splitTable;
      }
      db.fbOrderData.put(fbOrder, fbOrderId);
      // 🔥 IMPORTANT CHANGE IS HERE
      const documentNo = await SyncData(fbOrder, "upsertFbOrder", setLoading, "", true, cart);

      // ✅ guaranteed correct orderId
      const orderId = documentNo || localStorage.getItem("orderId");

      if (posConfig?.enableKOTPrint === "Y") {
        if (CWHardwareController) {
          const finalFilteredCart = {
            ...filteredCart,
            orderId,
          };
          CWKOTPrinter(finalFilteredCart);
        } else {
          kotPrinter(array1, fbOrder.fbOrderId);
        }
      }
    }
    const updatedTableData = await db.tableData.toArray();
    const updatedTable = updatedTableData.find((t) => t.cwrFbTableId === recordState?.cwrFbTableId);

    if (updatedTable) {
      await SyncData(updatedTable, "upsertTableStatus");
    }
    setTableCards(updatedTableData);
    const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU" || table.statusType === "ONG");
    setOcupiedTablesData(ocuTables);
    const resTables = updatedTableData.filter((table) => table.statusType === "RES");
    setReservedTablesData(resTables);
    let tempData = [];
    await db.tableData.toArray().then((fetched) => {
      tempData.push(...fetched);
    });
    setTableList(tempData);

    const tableOccupied = newCart?.statusType === "OCU";
    if (!tableOccupied) {
      const newDocumentSequence = documentSequence + 1;
      localStorage.setItem("documentSequence", newDocumentSequence);
      setDocumnetSequence(newDocumentSequence);
    }

    if (cart.saleType.value !== "TA") {
      setKeyValue("0");
    }
    if (allItemsFired) {
      setShowProducts(false);
    }
  };

  const hasUnfiredItems = cart.items.some((item) => item.order !== "Y" && !item.isHold);
  // Kitchen Display Modal Starts //

  const orderStatus = [
    {
      title: "All",
      imgSrc: All,
      statusValue: "NE",
    },
    {
      title: "Parked",
      imgSrc: ParkedOrder,
      statusValue: "NE",
    },
    {
      title: "Pending",
      imgSrc: Pending,
      statusValue: "NE",
    },
    {
      title: "In Progress",
      imgSrc: InProgress,
      statusValue: "UP",
    },
    {
      title: "Prepared",
      imgSrc: Prepared,
      statusValue: "PR",
    },
    {
      title: "Completed",
      imgSrc: Completed,
      statusValue: "DE",
    },
  ];

  const [displayOrderItemsModal, setDisplayOrderItemsModal] = useState(false);
  const [selectedOrderStatus, setSelectedOrderStatus] = useState(orderStatus[0]);

  const orderDetailsList = JSON.parse(localStorage.getItem("orderDetails"));
  const initialOrderList = orderDetailsList ? orderDetailsList : [];
  const [orderDetails, setOrderDetails] = useState(initialOrderList);

  const handleOrderStatus = async () => {
    db.orders
      .orderBy("orderTime")
      .limit(20)
      .reverse()
      .toArray()
      .then((data) => {
        if (data?.length > 0) {
          data?.map((item) => {
            let time = new Date(item.orderTime);
            let newTime = time.toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            });
            let newLineItems = item?.items?.map((itemLine) => ({
              ...itemLine,
              price: itemLine?.salesPrice || 0,
              quantity: itemLine?.weight || 0,
            }));
            let orderObj = {
              cWCOrderId: item.sOrderID || "",
              customerId: item?.customer?.cwrCustomerId || "",
              customerName: item?.customer?.name || "",
              lineItems: [...newLineItems],
              mobileNo: item?.customer?.mobileNo,
              noOfItems: item?.items?.length,
              orderNo: item.documentno,
              posOrders: "Y",
              status: "NE",
              total: item?.total || 0,
              totalQty: item?.totalQty || 0,
              dateCreated: newTime,
            };
            let findIndexOrder = _.findIndex(orderDetails, ["cWCOrderId", orderObj.cWCOrderId]);
            if (findIndexOrder === -1) {
              orderDetails.push(orderObj);
            } else {
              orderDetails[findIndexOrder] = orderObj;
            }
            return null;
          });
        }
      });
    const paramsInput = {
      query: `query{
        getNewOmsOrders(bunitId:"${tillData.tillAccess.csBunit.csBunitId}"){
        cWCOrderId
        orderNo
        dateCreated
        customerId
        customerName
        mobileNo
        total
        noOfItems
        totalQty
        lineItems{
            productId
            name
            productCode
            quantity
            price
            subTotal
            addOnProducts{
                id
                name
                price
            }
        }
    }
    }`,
    };
    try {
      const response = await getNewOmsOrder(paramsInput);
      const { getNewOmsOrders } = response.data.data;
      getNewOmsOrders?.map((item, index) => {
        let obj = { ...item };
        obj.status = "NE";
        obj.noOfItems = item.lineItems.length;
        obj.posOrders = "N";
        let time = new Date(item.dateCreated);
        let newTime = time.toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
        obj.dateCreated = newTime;
        let findIndex = _.findIndex(orderDetails, ["cWCOrderId", item.cWCOrderId]);
        if (findIndex === -1) {
          orderDetails.push(obj);
        } else {
          orderDetails[findIndex] = obj;
        }
        return null;
      });
      localStorage.setItem("orderDetails", JSON.stringify([...orderDetails]));
      setOrderDetails([...orderDetails]);
    } catch (err) {
      console.log(err);
    }
    setDisplayOrderItemsModal(true);
  };

  const handleOrderStatusSelection = (record) => {
    setSelectedOrderStatus(record);
  };

  const nextOrderStatus = () => {
    let newOrderStatus = [...orderStatus];
    let statusIndex = _.findIndex(newOrderStatus, (item) => item.title === selectedOrderStatus.title);
    if (statusIndex <= newOrderStatus.length - 1) setSelectedOrderStatus(newOrderStatus[statusIndex + 1]);
  };

  const setStatus = (status) => {
    let newStatus = "";
    switch (status) {
      case "NE":
        newStatus = "UP";
        break;
      case "UP":
        newStatus = "PR";
        break;
      case "PR":
        newStatus = "DE";
        break;
      default:
        newStatus = "NE";
    }
    return newStatus;
  };

  const handleStatusButton = (record) => {
    if ((record.status === "NE" || record.status === "UP" || record.status === "PR") && record.posOrders === "N") {
      handleInProgress(record);
    } else {
      let newOrderDetails = [...orderDetails];
      let recordIndex = _.findIndex(newOrderDetails, ["cWCOrderId", record.cWCOrderId]);
      newOrderDetails[recordIndex].status = setStatus(record.status);
      localStorage.setItem("orderDetails", JSON.stringify(orderDetails));
      setOrderDetails([...newOrderDetails]);
      nextOrderStatus();
    }
  };

  const handleInProgress = async (record) => {
    const paramsInput = {
      query: `mutation{
        updateOMSOrderStatus(order:{
            cWCOrderId: "${record.cWCOrderId}"
            status: "${record.status}"
        })
        {
            status
            message
        }
    }`,
    };
    try {
      const response = await updateOMSOrderStatus(paramsInput);
      if (response?.data?.data?.updateOMSOrderStatus?.status === "200") {
        let newOrderDetails = [...orderDetails];
        let recordIndex = _.findIndex(newOrderDetails, ["cWCOrderId", record.cWCOrderId]);
        newOrderDetails[recordIndex].status = setStatus(record.status);
        localStorage.setItem("orderDetails", JSON.stringify(orderDetails));
        setOrderDetails([...newOrderDetails]);
        nextOrderStatus();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [barcodeOrderList, setBarcodeOrderList] = useState([]);
  const [barcodeOrderStatusModal, setBarcodeOrderStatusModal] = useState(false);

  const handleAccept = async (record) => {
    const paramsInput = {
      query: `mutation{
        updateOMSOrderStatus(order:{
            cWCOrderId: "${record.cWCOrderId}"
            status: "DE"
        })
        {
            status
            message
        }
    }`,
    };
    try {
      const response = await updateOMSOrderStatus(paramsInput);
      if (response?.data?.data?.updateOMSOrderStatus?.status === "200") {
        message.success(`Order ${barcodeOrderList[0]?.orderNo} ${messages.errors.cart.completed_successfully}`);
        setBarcodeOrderStatusModal(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBarcodeOrderPrint = (printedData) => {
    const printWindow = window.open("", "printWindow", "width=0,height=0");
    let printedDataArray = printedData?.lineItems?.map((item) => ({
      ...item,
      productName: item?.name,
      price: item?.price,
      qty: item?.quantity,
    }));
    const barcodeOrderData = `
      <html>
      <style>
      th,td {
        padding: 15px;
      }
      </style>
        <div style="width:100%;">
        <div style="text-align:center; margin-bottom: 20px;"><h4>${tillData.tillAccess.csBunit.name}</h4></div>
        <div style="display:flex; margin-bottom: 20px;">
        <span>Order No</span>
          <span style="margin-left: 100px;">${printedData.orderNo}</span>
        </div>
        <div style="display:flex; margin-bottom: 20px;">
        <span>Date</span>
          <span style="margin-left: 100px;">${printedData.dateCreated}</span>
        </div>
        <hr />
        <table style="width:100%">
              <tr>
                <th style="text-align:left;"><strong>Product</strong></th>
                <th style="text-align:left;"><strong>Qty</strong></th>
                <th style="text-align:left;"><strong>Price</strong></th>
              </tr>
              ${printedDataArray?.map((item) => {
                return `<tr>
                  <td>${item.productName}</td>
                  <td>${item.qty}</td>
                  <td>${item.price}</td>
                </tr>
                ${item?.addOnProducts?.map((addonItem) => {
                  return `<tr>
                    <td>--${addonItem.name}</td>
                    </tr>`;
                })}
               `;
              })}
          </table>
          <div style="display:flex; margin-top: 30px;">
          <h2>Total</h2>
            <h2 style="margin-left: 100px; text-align: end">${_.sumBy(printedDataArray, "price")}</h2>
          </div>
          <div style="text-align:center; margin-bottom: 20px;"><h4>Thank You</h4></div>
        </div>
      </html>`;
    printWindow.document.write(barcodeOrderData);
    printWindow.print();
    printWindow.close();
  };
  const [billConfirmationModalOpen, setBillConfirmationModalOpen] = useState(false);
  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const [layout, setLayout] = useState("default");
  const [inputs, setInputs] = useState({});
  const [inputName, setInputName] = useState("");
  const [categorieFlag, setCategorieFlag] = useState(false);
  const keyboard = useRef(null);
  const prevCustomerIdRef = useRef(null);
  const inputRef = useRef(null);

  const handleShift = () => {
    const newLayoutName = layout === "default" ? "shift" : "default";
    setLayout(newLayoutName);
  };

  const handleNotesValue = (event) => {
    const inputVal = event.target.value;
    setInputs({
      ...inputs,
      [inputName]: inputVal,
    });
    keyboard.current.setInput(inputVal);
  };

  const clearCart1 = async (type) => {
    const tillSession = JSON.parse(localStorage.getItem("tillSession"));
    const tillSessionId = tillSession.tillSessionId;
    const newDocumentSequence = cart.parked === "Y" || cart.statusType === "OCU" ? documentSequence : documentSequence + 1;
    let cartToDb = cart;
    cartToDb.orderTime = timeStamp();
    cartToDb.createdBy = tillData.tillAccess.csUserId;
    cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId;
    cartToDb.orderDate = moment(new Date()).format("YYYY-MM-DD");
    cartToDb.tillSessionId = tillSessionId;
    cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
    cartToDb.isSynced = 0;
    cartToDb.syncAttempts = 0;
    cartToDb.customerSearchKey = cart.customer.code;
    cartToDb.tax = 0;
    cartToDb.total = 0;
    cartToDb.docType = "Invoice";
    cartToDb.totalQty = 0;
    cartToDb.couponInput = [];
    cartToDb.discount = 0;
    cartToDb.isReturn = false;
    cartToDb.items.forEach((item) => {
      item.salePrice = 0;
      item.sunitprice = 0;
      item.netStd = 0;
      item.nettotal = 0;
      item.unitTax = 0;
      item.taxAmount = 0;
      item.weight = 0;
      item.unitPrice = 0;
      item.isReturn = false;
      item.netList = 0;
      item.discount = 0;
      item.linetax = 0;
      item.linenet = 0;
      item.linegross = 0;
      item.linestd = 0;
      item.netunit = 0;
      item.listPrice = 0;
      item.grossunit = 0;
      item.grossstd = 0;
      item.grosslist = 0;
    });
    deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
    setGiftCardData([]);
    if (type === "Layaway") {
      setDocumnetSequence(documentSequence);
    } else {
      localStorage.setItem("documentSequence", newDocumentSequence);
      setDocumnetSequence(newDocumentSequence);
      await db.orders.add(cartToDb);
    }
  };

  // const handleVoid = async (record, cancelItemIds) => {
  //   const { workflowRules, approvers } = await getWorkflowData();
  //   const cancelKotRule = workflowRules.find((res) => res.eventName === "Cancel KOT");

  //   if (cancelKotRule) {
  //     dispatchEvent(cancelKotRule.eventName, cancelKotRule.ruleName, cancelKotRule.ruleCondition, approvers, async (eventData) => {
  //       if (eventData?.approvalGranted) {
  //         await proceedWithCancellation(record);
  //       } else {
  //         Modal.error({
  //           title: "Approval Required",
  //           content: "The cancellation request was not approved.",
  //         });
  //       }
  //     });
  //   } else {
  //     await proceedWithCancellation(record);
  //   }

  //   async function proceedWithCancellation(record) {
  //     let shouldClearCart = false;
  //     const dineInKey = localStorage.getItem("dineIn");

  //     if (dineInKey === "Y") {
  //       const orders = await db.fbOrderData.where("cwrFbTableId").equals(record.cwrFbTableId).toArray();
  //       const ordersData = orders.find((order) => order.fbOrderStatus === "IP");
  //       const ordersFetched = ordersData ? [ordersData] : [];

  //       for (const fbOrder of ordersFetched) {
  //         if (fbOrder.fbOrderStatus !== "IP") continue;

  //         /* ---------------- fbOrder.lines (FIXED) ---------------- */
  //         fbOrder.lines = fbOrder.lines.map((line) => {
  //           const isAlreadyFinal = line.isCanceled === "Y";
  //           const shouldCancel = !isAlreadyFinal && cancelItemIds.includes(line.fbOrderLineId);

  //           return shouldCancel ? { ...line, isCanceled: "Y" } : line;
  //         });

  //         /* ---------------- fbOrder.cart.items ---------------- */
  //         if (fbOrder.cart?.items?.length) {
  //           fbOrder.cart.items = fbOrder.cart.items.map((item) => {
  //             const isAlreadyFinal = ["RC", "CO", "CL"].includes(item.orderStatus);
  //             const shouldCancel = !isAlreadyFinal && cancelItemIds.includes(item.fbOrderLineId);

  //             return shouldCancel ? { ...item, isCanceled: "Y", orderStatus: "CL" } : item;
  //           });
  //         }

  //         /* ---------------- localStorage cart ---------------- */
  //         let cartObj = JSON.parse(localStorage.getItem("cartObj"));
  //         if (cartObj?.items?.length) {
  //           cartObj.items = cartObj.items.map((item) => {
  //             const isAlreadyFinal = ["RC", "CO", "CL"].includes(item.orderStatus);
  //             const shouldCancel = !isAlreadyFinal && cancelItemIds.includes(item.fbOrderLineId);

  //             return shouldCancel ? { ...item, isCanceled: "Y", orderStatus: "CL" } : item;
  //           });

  //           localStorage.setItem("cartObj", JSON.stringify(cartObj));
  //         }

  //         /* ---------------- allCancelled (FIXED) ---------------- */
  //         const allCancelled = fbOrder.lines.every((l) => l.isCanceled === "Y");

  //         if (allCancelled) shouldClearCart = true;

  //         fbOrder.fbOrderStatus = allCancelled ? "CL" : "IP";
  //         fbOrder.isCanceled = allCancelled ? "Y" : "N";
  //         fbOrder.fbOrderSync = "N";

  //         await db.fbOrderData.where("fbOrderId").equals(fbOrder.fbOrderId).modify({
  //           fbOrderSync: "N",
  //           fbOrderStatus: fbOrder.fbOrderStatus,
  //           lines: fbOrder.lines,
  //           isCanceled: fbOrder.isCanceled,
  //           cart: fbOrder.cart,
  //         });

  //         if (fbOrder.cart) {
  //           localStorage.setItem("cartObj", JSON.stringify(fbOrder.cart));
  //           setCart(fbOrder.cart);
  //         }

  //         await SyncData(fbOrder, "upsertFbOrder", setLoading, "", true, cart);

  //         /* ---------------- Table / Split logic (UNCHANGED) ---------------- */
  //         const response = await db.tableData.where("cwrFbTableId").equals(record?.cwrFbTableId).toArray();

  //         if (!response.length) continue;

  //         let tableData = { ...response[0] };

  //         if (tableData.isSplitParent === "Y" && tableData.splitTables) {
  //           tableData.splitTables = tableData.splitTables.map((split) => {
  //             if (split.splitTable !== fbOrder.splitTable) return split;

  //             let updatedCart = split.cart;
  //             if (updatedCart?.items?.length) {
  //               updatedCart = {
  //                 ...updatedCart,
  //                 items: updatedCart.items.map((item) => {
  //                   const shouldCancel = cancelItemIds.includes(item.fbOrderLineId);
  //                   return shouldCancel ? { ...item, isCanceled: "Y", orderStatus: "CL" } : item;
  //                 }),
  //               };
  //             }

  //             return {
  //               ...split,
  //               status: allCancelled ? "OPN" : "ONG",
  //               cart: updatedCart,
  //             };
  //           });

  //           const currentSplit = tableData.splitTables.find((s) => s.splitTable === fbOrder.splitTable);

  //           if (currentSplit?.cart?.items?.length && currentSplit.cart.items.every((i) => i.isCanceled === "Y")) {
  //             shouldClearCart = true;
  //           }

  //           tableData.tabbleSync = "N";
  //           await db.tableData.put(tableData, tableData.cwrFbTableId);

  //           await SyncData(
  //             {
  //               fbtableStatusId: tableData.fbtableStatusId,
  //               cwrFbTableId: tableData.cwrFbTableId,
  //               splitTables: tableData.splitTables,
  //               statusType: tableData.statusType,
  //               waiter: tableData.waiter,
  //             },
  //             "upsertTableStatus"
  //           );
  //         } else {
  //           tableData.statusType = allCancelled ? "OPN" : "ONG";
  //           tableData.color = "rgba(146, 144, 152, 0.5)";
  //         }

  //         await SyncData(tableData, "upsertTableStatus");

  //         await db.tableData.update(tableData.cwrFbTableId, {
  //           color: "rgba(146, 144, 152, 0.5)",
  //           noOfPersons: "",
  //           guestName: "",
  //           guestType: "",
  //           referredBy: "",
  //           statusType: allCancelled ? "OPN" : "ONG",
  //           items: [],
  //           ordered: "N",
  //         });

  //         history.push("/pos");
  //         setKeyValue("0");
  //         setShowProducts(false);
  //       }

  //       if (shouldClearCart) {
  //         clearCart1(cart.type);
  //       }
  //     } else {
  //       setCategorieFlag(false);
  //       clearCart1(cart.type);
  //     }
  //   }
  // };
  const handleVoid = async (record, cancelItemIds) => {
    const { workflowRules, approvers } = await getWorkflowData();
    const cancelKotRule = workflowRules.find((res) => res.eventName === "Cancel KOT");

    if (cancelKotRule) {
      dispatchEvent(cancelKotRule.eventName, cancelKotRule.ruleName, cancelKotRule.ruleCondition, approvers, async (eventData) => {
        if (eventData?.approvalGranted) {
          await proceedWithCancellation(record);
        } else {
          Modal.error({
            title: "Approval Required",
            content: "The cancellation request was not approved.",
          });
        }
      });
    } else {
      await proceedWithCancellation(record);
    }

    async function proceedWithCancellation(record) {
      let shouldClearCart = false;
      const dineInKey = localStorage.getItem("dineIn");

      if (dineInKey === "Y") {
        const orders = await db.fbOrderData.where("cwrFbTableId").equals(record.cwrFbTableId).toArray();
        const ordersData = orders.find((order) => order.fbOrderStatus === "IP");
        const ordersFetched = ordersData ? [ordersData] : [];

        for (const fbOrder of ordersFetched) {
          if (fbOrder.fbOrderStatus !== "IP") continue;

          // Guard against missing/empty lines array
          if (!Array.isArray(fbOrder.lines) || fbOrder.lines.length === 0) {
            console.warn("[handleVoid] fbOrder.lines is empty or missing, skipping:", fbOrder.fbOrderId);
            continue;
          }

          // Guard against missing/invalid cancelItemIds
          if (!Array.isArray(cancelItemIds) || cancelItemIds.length === 0) {
            console.warn("[handleVoid] cancelItemIds is empty or invalid, aborting cancellation");
            return;
          }

          /* ---------------- fbOrder.lines ---------------- */
          fbOrder.lines = fbOrder.lines.map((line) => {
            const isAlreadyFinal = line.isCanceled === "Y";
            const shouldCancel = !isAlreadyFinal && cancelItemIds.includes(line.fbOrderLineId);

            return shouldCancel ? { ...line, isCanceled: "Y" } : line;
          });

          /* ---------------- fbOrder.cart.items ---------------- */
          if (fbOrder.cart?.items?.length) {
            fbOrder.cart.items = fbOrder.cart.items.map((item) => {
              const isAlreadyFinal = ["RC", "CO", "CL"].includes(item.orderStatus);
              const shouldCancel = !isAlreadyFinal && cancelItemIds.includes(item.fbOrderLineId);

              return shouldCancel ? { ...item, isCanceled: "Y", orderStatus: "CL" } : item;
            });
          }

          /* ---------------- itemsSummery + groupedItemsByTaxRate recalculation ---------------- */
          // Derive taxIncludeFlag locally (same logic as point-ofsale-core)
          const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData") || "{}");
          const taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
          const roundTo = (value, decimals = 2) => Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals);

          const itemsSummery = {
            decimalItems: { totalQty: 0, totalAmount: 0 },
            nonDecimalItems: { totalQty: 0, totalAmount: 0 },
            itemsQty: 0,
            items: 0,
          };

          // Group only active (non-cancelled) items by tax rate
          const allItems = (fbOrder.cart?.items || [])
            .filter((i) => i?.isCanceled !== "Y")
            .flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));

          const groupedItems = allItems.reduce((acc, item) => {
            const key = item.tax?.rate ?? item.taxRate ?? "0";
            acc[key] = acc[key] || [];
            acc[key].push(item);
            return acc;
          }, {});

          const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
            const totalTaxAmount = items.reduce((sum, item) => {
              const taxValue = item.taxAmount || 0;
              return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
            }, 0);

            const totalNetTotal = items.reduce((sum, item) => {
              const netValue = item.nettotal || 0;
              return sum + parseFloat(netValue);
            }, 0);

            const totalSgstAmount = items.reduce((sum, item) => {
              const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || 0) / 2;
              return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
            }, 0);

            const totalCgstAmount = items.reduce((sum, item) => {
              const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || 0) / 2;
              return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
            }, 0);

            return {
              taxRate,
              totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
              totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
              totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
              totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
              totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
            };
          });

          // Recalculate totals and line-level fields for active items, build itemsSummery
          let updatedTotalTax = 0;
          let updatedTotalPrice = 0;
          let updatedTotalItemsQty = 0;
          let updatedTotalDiscounts = 0;
          let updatedTotalStd = 0;

          if (fbOrder.cart?.items?.length) {
            fbOrder.cart.items = fbOrder.cart.items.map((item, i) => {
              if (item.isCanceled === "Y") {
                item.discount = 0;
                item.key = i;
                return item;
              }
              const nettotalFixed = parseFloat(parseFloat(item?.nettotal)?.toFixed(precision));
              const taxAmountFixed = parseFloat(parseFloat(item?.taxAmount)?.toFixed(precision));
              const discountFixed = item.discount ? parseFloat(parseFloat(item?.discount)?.toFixed(precision)) : 0;

              updatedTotalPrice += nettotalFixed;
              updatedTotalItemsQty += item.weight;
              updatedTotalTax += taxAmountFixed;
              updatedTotalDiscounts += discountFixed;

              item.discount = discountFixed;
              item.key = i;

              if (!item.isGiftCard) {
                const unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;
                const lineTax = item.listPrice * (1 + (item.taxRate || 0) / 100);
                const stdTax = item.sunitprice * (1 + (item.taxRate || 0) / 100);
                const netList =
                  taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
                const gross_list = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
                const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(stdTax)?.toFixed(precision));

                Object.assign(item, {
                  linetax: nettotalFixed ? taxAmountFixed : 0,
                  linenet: nettotalFixed ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0,
                  linegross: nettotalFixed || 0,
                  linestd: nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0,
                  netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
                  listprice: nettotalFixed ? item.listPrice : 0,
                  grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
                  grossstd: nettotalFixed ? grossStd : 0,
                  grosslist: nettotalFixed ? roundTo(gross_list, precision) : 0,
                  netList: nettotalFixed ? netList : 0,
                  unitPrice: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
                  taxAmount: nettotalFixed ? taxAmountFixed : 0,
                });

                updatedTotalStd += nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0;
              }

              // Build itemsSummery
              if (Array.isArray(item.children) && item.children.length > 0) {
                item.children.forEach((child) => {
                  const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
                  const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";
                  itemsSummery.itemsQty += child.weight;
                  itemsSummery.items += 1;
                  itemsSummery[summaryKey].totalQty += child.weight;
                  itemsSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
                });
              } else {
                const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
                const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";
                itemsSummery.itemsQty += item.weight;
                itemsSummery.items += 1;
                itemsSummery[summaryKey].totalQty += item.weight;
                itemsSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
              }

              return item;
            });

            // Set recalculated totals and summaries on the cart
            fbOrder.cart.total = parseFloat(updatedTotalPrice.toFixed(precision));
            fbOrder.cart.tax = updatedTotalTax;
            fbOrder.cart.discount = updatedTotalDiscounts;
            fbOrder.cart.totalQty = updatedTotalItemsQty;
            fbOrder.cart.subTotal = parseFloat(parseFloat(updatedTotalPrice - updatedTotalTax)?.toFixed(precision));
            fbOrder.cart.totalStd = updatedTotalStd;
            fbOrder.cart.itemsSummery = itemsSummery;
            fbOrder.cart.groupedItemsByTaxRate = groupedItemsByTaxRate;
          }

          // Update wsData with cancelled items + recalculated totals/summaries
          if (fbOrder.wsData && typeof fbOrder.wsData === "object" && Object.keys(fbOrder.wsData).length > 0) {
            if (Array.isArray(fbOrder.wsData.items) && fbOrder.wsData.items.length > 0) {
              fbOrder.wsData = {
                ...fbOrder.wsData,
                items: fbOrder.wsData.items.map((item) => {
                  const isAlreadyFinal = item.isCanceled === "Y" || ["RC", "CO", "CL"].includes(item.orderStatus);
                  const shouldCancel = !isAlreadyFinal && cancelItemIds.includes(item.fbOrderLineId);
                  return shouldCancel ? { ...item, isCanceled: "Y", orderStatus: "CL" } : item;
                }),
                total: fbOrder.cart?.total,
                tax: fbOrder.cart?.tax,
                discount: fbOrder.cart?.discount,
                totalQty: fbOrder.cart?.totalQty,
                subTotal: fbOrder.cart?.subTotal,
                totalStd: fbOrder.cart?.totalStd,
                itemsSummery: fbOrder.cart?.itemsSummery,
                groupedItemsByTaxRate: fbOrder.cart?.groupedItemsByTaxRate,
              };
            }
          }

          /* ---------------- localStorage cart ---------------- */
          // Write the fully recalculated fbOrder.cart (with itemsSummery, groupedItemsByTaxRate,
          // updated totals, and cancelled statuses) directly to localStorage.
          // This replaces the previous approach of only marking items as cancelled on the
          // stale cartObj, which left totals/summaries out of sync.
          if (fbOrder.cart) {
            localStorage.setItem("cartObj", JSON.stringify(fbOrder.cart));
          }

          /* ---------------- allCancelled check ---------------- */
          const allLinesCancelled = fbOrder.lines.every((l) => l.isCanceled === "Y");
          const allCartItemsCancelled = fbOrder.cart?.items?.length ? fbOrder.cart.items.every((item) => item.isCanceled === "Y" || item.orderStatus === "CL") : true;
          const allCancelled = allLinesCancelled && allCartItemsCancelled;

          if (allCancelled) shouldClearCart = true;

          fbOrder.fbOrderStatus = allCancelled ? "CL" : "IP";
          fbOrder.isCanceled = allCancelled ? "Y" : "N";
          fbOrder.fbOrderSync = "N";

          // Persist wsData along with other fields to Dexie
          await db.fbOrderData
            .where("fbOrderId")
            .equals(fbOrder.fbOrderId)
            .modify({
              fbOrderSync: "N",
              fbOrderStatus: fbOrder.fbOrderStatus,
              lines: fbOrder.lines,
              isCanceled: fbOrder.isCanceled,
              cart: fbOrder.cart,
              wsData: allCancelled ? {} : fbOrder.wsData,
            });

          if (fbOrder.cart) {
            setCart(fbOrder.cart);
          }

          // Pass fbOrder.cart (the UPDATED cart with itemsSummery) instead of stale `cart` closure
          await SyncData(fbOrder, "upsertFbOrder", setLoading, "", true, fbOrder.cart);

          /* ---------------- Table / Split logic ---------------- */
          const response = await db.tableData.where("cwrFbTableId").equals(record?.cwrFbTableId).toArray();

          if (!response.length) continue;

          let tableData = { ...response[0] };

          if (tableData.isSplitParent === "Y" && tableData.splitTables) {
            tableData.splitTables = tableData.splitTables.map((split) => {
              if (split.splitTable !== fbOrder.splitTable) return split;

              // Use fbOrder.cart directly for the matching split -- it already has
              // cancelled statuses, recalculated totals, itemsSummery, and groupedItemsByTaxRate.
              // This ensures the split table cart is fully in sync with the fbOrder.
              return {
                ...split,
                status: allCancelled ? "OPN" : "ONG",
                cart: fbOrder.cart,
              };
            });

            const currentSplit = tableData.splitTables.find((s) => s.splitTable === fbOrder.splitTable);

            if (currentSplit?.cart?.items?.length && currentSplit.cart.items.every((i) => i.isCanceled === "Y")) {
              shouldClearCart = true;
            }

            tableData.tabbleSync = "N";
            await db.tableData.put(tableData, tableData.cwrFbTableId);

            await SyncData(
              {
                fbtableStatusId: tableData.fbtableStatusId,
                cwrFbTableId: tableData.cwrFbTableId,
                splitTables: tableData.splitTables,
                statusType: tableData.statusType,
                waiter: tableData.waiter,
              },
              "upsertTableStatus"
            );
          } else {
            // Also update wsData on tableData so next table open reads correct state
            tableData.statusType = allCancelled ? "OPN" : "ONG";
            tableData.color = "rgba(146, 144, 152, 0.5)";
            tableData.wsData = allCancelled ? {} : fbOrder.wsData;
          }

          await SyncData(tableData, "upsertTableStatus");

          await db.tableData.update(tableData.cwrFbTableId, {
            color: "rgba(146, 144, 152, 0.5)",
            noOfPersons: allCancelled ? "" : tableData.noOfPersons,
            guestName: allCancelled ? "" : tableData.guestName,
            guestType: allCancelled ? "" : tableData.guestType,
            referredBy: allCancelled ? "" : tableData.referredBy,
            statusType: allCancelled ? "OPN" : "ONG",
            items: allCancelled ? [] : fbOrder.wsData?.items || [],
            wsData: allCancelled ? {} : fbOrder.wsData,
            ordered: allCancelled ? "N" : "Y",
          });

          history.push("/pos");
          setKeyValue("0");
          setShowProducts(false);
        }

        if (shouldClearCart) {
          clearCart1(cart.type);
        }
      } else {
        setCategorieFlag(false);
        clearCart1(cart.type);
      }
    }
  };

  const tillUnlink = async () => {
    let parkedBills = JSON.parse(localStorage.getItem("parkedList"));
    let posConfig = JSON.parse(localStorage.getItem("posConfig"));
    const orders = await db.orders.where("isSynced").equals(0).toArray();
    if (parkedBills?.length > 0) {
      {
        message.error(`${t("unlink_till_parked_bill_error")}`);
      }
    } else if (cart?.items?.length > 0) {
      {
        message.error(`${t("unlink_till_cart_error")}`);
      }
    } else if (orders?.length > 0) {
      message.error(`${messages.errors.till_management.unlink_till_sync_po}`);
    } else {
      // If none of the conditions is satisfied, you can provide a default message
      if (posConfig?.shiftClose === "Y") {
        if (posConfig?.showDenominations === "Y") {
          history.push("/close-till");
          localStorage.setItem("unlink", true);
        } else if (posConfig?.showDenominations === "N") {
          history.push("/close-till-all");
          localStorage.setItem("unlink", true);
        }
      } else {
        history.push("/");
      }
    }
  };

  const [isUnlinkTillClicked, setIsUnlinkTillClicked] = useState(false);

  const handleUnlinkTillClick = () => {
    if (cart.paid > 0) {
      message.warning(`${messages.errors.till_management.delete_payment_method}`);
      return;
    }
    if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
      message.warning(`${messages.errors.cart.cart_switch_section}`);
      return;
    }
    if (showSendToKitchen && hasUnfiredItems) {
      message.warning(`${messages.errors.cart.cart_switch_section}`);
      return;
    }
    if (splitBillScreen) {
      message.warning(messages.errors.cart.cart_switch_section);
      return; // stop navigation
    }
    setIsUnlinkTillClicked(true);
    tillUnlink();
  };

  useEffect(() => {
    if (keyValue === "0" && accessController?.dineIn === "N") {
      setKeyValue("2");
    }
  }, []);

  useEffect(() => {
    if (cart?.items?.length > 0) {
      const preciseTotal = parseFloat(cart?.total?.toFixed(precision));

      let updatedCart = {
        ...cart,
        total: preciseTotal,
        totalStd: cart?.items?.reduce((sum, item) => (item?.isCanceled === "Y" ? sum : sum + (item?.linestd || 0)), 0) || 0,
        amountInWords: numberToWords(preciseTotal),
      };

      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    }
  }, [cart]);

  const restaurantProductCategory = async (categorie) => {
    const filteredProducts = saleTypeProducts.filter((product) => product.mProductCategoryId === categorie);
    setProductsData(filteredProducts);
  };

  const antIcon = <LoadingOutlined style={{ fontSize: "24px" }} spin />;
  const tableLayoutProps = {
    setSelectedSaleTypeIndex,
    cancelKotItems,
    setCancelKotItems,
    transferBill,
    setTransferBill,
    seatGuestDrawerOpen,
    setSeatGuestDrawerOpen,
    selectData,
    setSelectData,
    orderFlags,
    setOrderFlags,
    setFiltersFlag,
    guestsModalFlag,
    setGuestsModalFlag,
    noOfPersons,
    setNumberOfPersons,
    priorityBtn,
    setPriorityBtn,
    getCustomerData,
    selectedProducts,
    setSelectedproducts,
    removeSplit,
    setRemoveSplit,
    clearCart,
    isSplitBill,
    setIsSplitBill,
    currentSplitIndex,
    setCurrentSplitIndex,
    splitCarts,
    setSplitCarts,
    showAllItems,
    setShowAllItems,
    numSplits,
    setNumSplits,
    splitBillScreen,
    setSplitBillScreen,
    showSplitBill,
    setShowSplitBill,
    tableList,
    setTableList,
    saleType,
    setSaleType,
    handleAmount,
    handleCashPayment,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    requestPayment,
    amount,
    setAmount,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    posConfig,
    setSelectedProductInCart,
    selectedProductId,
    setSelectedProductId,
    manualDiscountRestaurant,
    filteredPaymentMethods,
    getFilteredPaymentMethods,
    keyValue,
    setKeyValue,
    cart,
    setCart,
    showProducts,
    setShowProducts,
    cart,
    selectedSaleType,
    setSelectedSaleType,
    selectProductCategory,
    restaurantProductCategory,
    productsData,
    pickProduct,
    handleAddOnModal,
    decreaseProductQty,
    deleteProduct,
    increaseProductQty,
    handleOrder,
    handleVoid,
    setAddCashFlag,
    setCashAddInFlag,
    selectedTable,
    setSelectedTable,
    setKeyValue,
    keyValue,
    paymentVisible,
    setPaymentVisible,
    setSelectedTable,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    addDefinedProductWithAddons,
    userPreferences,
    occupiedDataTablesData,
    setOcupiedTablesData,
    reservedTablesData,
    setReservedTablesData,
    saleTypeProducts,
    setSaleTypeProducts,
    paymentVisible,
    setNumb,
    processOrder,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    userData,
    tillValue,
    defaultCustomer,
    clearCartData,
    recordState,
    setRecardState,
    mainTableData,
    showSendToKitchen,
    setShowSendToKitchen,
    getSalesHistoryData,
    isPrintModeXML,
    upsertPOSLog,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    searchHistoryInput,
    setSearchhistoryInput,
    ordersCopy,
    dateRef,
    filtersFlag,
    ...props,
  };
  const calls = [
    { name: "Rahul Verma", phone: "+91 98765 43210", city: "Bengaluru", loyalty: 420, holdTime: "4:05", priority: "HIGH" },
    { name: "Priya Sharma", phone: "+91 87654 32109", city: "Bengaluru", loyalty: 280, holdTime: "3:00", priority: "HIGH" },
    { name: "Amit Patel", phone: "+91 76543 21098", city: "Indiranagar", loyalty: 150, holdTime: "2:00", priority: "MEDIUM" },
    { name: "Neha Gupta", phone: "+91 65432 10987", city: "Koramangala", loyalty: 320, holdTime: "1:35", priority: "MEDIUM" },
    { name: "Vikram Singh", phone: "+91 54321 09876", city: "Whitefield", loyalty: 85, holdTime: "1:00", priority: "LOW" },
    { name: "Anjali Desai", phone: "+91 43210 98765", city: "HSR Layout", loyalty: 200, holdTime: "0:45", priority: "LOW" },
  ];

  const processedTableUpdateIdsRef = useRef(new Set());

  const handleWebSocketMessage = useCallback(async (message) => {
    try {
      switch (message.type) {
        case "TABLE_STATUS_UPDATE":
        case "TABLE_UPDATE":
          if (message) {
            const updateId = `${message.data?.fbTableId}_${message.data?.status}_${message.timestamp || Date.now()}`;

            if (processedTableUpdateIdsRef.current.has(updateId)) {
              console.log(`[v0] [HandleMessage] Skipping duplicate table update: ${message.data?.fbTableId}`);
              return;
            }

            if (message.data) {
              const allTableData = await db.tableData.toArray();
              console.log("[v0] [HandleMessage] All table data:", allTableData);

              // <CHANGE> Prevent processing if database is empty
              if (!allTableData || allTableData.length === 0) {
                console.warn("[v0] [HandleMessage] Database is empty, skipping TABLE_UPDATE until initial data is loaded");
                return;
              }

              const data = [];
              let tableFound = false;

              allTableData.map((ele) => {
                if (message?.data?.fbTableId === ele.cwrFbTableId) {
                  ele.statusType = message?.data?.status;
                  ele.tabbleSync = "Y";
                  ele.merge = message?.data?.status === "OPN" && message?.data?.merges?.length > 0 ? [] : message?.data?.merges || [];
                  ele.startedAt = message?.data?.status === "STD" ? moment().format("YYYY-MM-DD HH:mm") : ele?.startedAt;
                  ele.guestName = message?.data?.guestName ? message?.data?.guestName : "";
                  tableFound = true;
                  if (message.data?.salesRepId) {
                    ele.waiter = message.data?.salesRepId;
                  }
                }
                data.push(ele);
              });

              if (!tableFound) {
                console.warn(`[v0] [HandleMessage] Table ${message.data.fbTableId} not found in database, update skipped`);
              }

              console.log("[v0] [HandleMessage] Updated data to save:", data);

              // <CHANGE> Validate data array before database operations
              if (!data || data.length === 0) {
                console.error("[v0] [HandleMessage] CRITICAL: Data array is empty, aborting database update");
                return;
              }

              if (data.length !== allTableData.length) {
                console.error("[v0] [HandleMessage] CRITICAL: Data length mismatch - Original:", allTableData.length, "New:", data.length);
                return;
              }

              await db.tableData.clear();
              await db.tableData.bulkPut(data);

              const updatedTableData = await db.tableData.toArray();

              // <CHANGE> Rollback if database became empty after update
              if (!updatedTableData || updatedTableData.length === 0) {
                console.error("[v0] [HandleMessage] CRITICAL: Database empty after update, restoring...");
                await db.tableData.bulkPut(allTableData);
                return;
              }

              setTableCards(updatedTableData);

              const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU" || table.statusType === "ONG");
              setOcupiedTablesData(ocuTables);

              const resTables = updatedTableData.filter((table) => table.statusType === "RES");
              setReservedTablesData(resTables);

              const tempData = [];
              await db.tableData.toArray().then((fetched) => {
                tempData.push(...fetched);
              });
              setTableList(tempData);

              processedTableUpdateIdsRef.current.add(updateId);
              if (processedTableUpdateIdsRef.current.size > 500) {
                const entries = Array.from(processedTableUpdateIdsRef.current);
                processedTableUpdateIdsRef.current = new Set(entries.slice(-500));
              }
            }
          }
          break;

        case "SUBSCRIBED":
          console.log("[v0] [HandleMessage] SUBSCRIBED to bunit:", message.bunitId);
          break;

        case "ORDER_UPSERT":
          console.log("[v0] [HandleMessage] Processing ORDER_UPSERT");

          if (message && message.data) {
            const orderId = message?.data?.fbOrderId || message.orderId;

            if (!orderId) {
              console.warn("[v0] [HandleMessage] ORDER_UPSERT missing orderId");
              break;
            }

            const orderUpdateId = `${orderId}_${message.timestamp || Date.now()}`;

            if (processedTableUpdateIdsRef.current.has(orderUpdateId)) {
              console.log(`[v0] [HandleMessage] Skipping duplicate order update: ${orderId}`);
              return;
            }

            try {
              const fbOrderId = message?.data?.fbOrderId;
              const fbTableId = message?.data?.fbTableId;
              const existingTable = await db.tableData.where("cwrFbTableId").equals(fbTableId).first();
              // Get existing record
              const existingOrder = await db.fbOrderData.where("fbOrderId").equals(fbOrderId).first();
              if (existingOrder) {
                // Update only changed fields
                await db.fbOrderData.update(existingOrder.id, {
                  fbOrderStatus: message.data.status,
                  name: existingTable?.name || existingTable?.table,
                  lines: message?.data?.lines.length > 0 ? message?.data?.lines : [],
                  wsData: message?.data?.meta.length > 0 && message.data.status !== "CL" ? JSON.parse(message?.data?.meta[0].value) : {},
                });

                console.log("[v0] ORDER_UPSERT: updated existing fbOrderData", fbOrderId);
              } else {
                await db.fbOrderData.add({
                  fbOrderId,
                  fbOrderStatus: message.data.status,
                  fbOrderSync: "Y",
                  cwrFbTableId: message.data.fbTableId,
                  lines: message.data.lines,
                  name: existingTable?.name || existingTable?.table,
                  wsData: message?.data?.meta.length > 0 && message.data.status !== "CL" ? JSON.parse(message?.data?.meta[0].value) : {},
                });

                console.log("[v0] ORDER_UPSERT: inserted new fbOrderData", fbOrderId, message.data.lines);
              }
              if (existingTable) {
                // Update only lines (or other fields if needed)
                await db.tableData.update(existingTable.cwrFbTableId, {
                  lines: message.data.status !== "CO" ? (message.data.lines ? message.data.lines : []) : [],
                  items: message?.data?.meta.length > 0 ? JSON.parse(message?.data?.meta[0].value)?.items : [],
                  wsData: message?.data?.meta.length > 0 && message.data.status !== "CL" ? JSON.parse(message?.data?.meta[0].value) : {},
                });

                console.log("[v0] ORDER_UPSERT: updated existing tableData", fbOrderId);
              }

              processedTableUpdateIdsRef.current.add(orderUpdateId);
              if (processedTableUpdateIdsRef.current.size > 500) {
                processedTableUpdateIdsRef.current = new Set([...processedTableUpdateIdsRef.current].slice(-500));
              }

              const tableData = JSON.parse(localStorage.getItem("tableName"));

              if (tableData) {
                if (tableData?.cwrFbTableId === message?.data?.fbTableId) {
                  setShowProducts(false);
                }
              }
            } catch (error) {
              console.error("[v0] ORDER_UPSERT Error:", error);
            }
          } else {
            console.warn("[v0] [HandleMessage] Empty ORDER_UPSERT message");
          }
          break;

        case "NEW_KOT":
          if (message && message.order) {
            if (message.order?.status) {
              showKDSNotification(message.order);
            }
            try {
              const kotOrder = message.order;
              if (!kotOrder?.orderId || !Array.isArray(kotOrder.line)) {
                console.warn("[KDS] Invalid NEW_KOT payload");
                break;
              }

              // 1️⃣ Find matching fbOrderData record
              const fbOrder = await db.fbOrderData.filter((order) => order?.cart?.sOrderID === kotOrder.orderId).first();

              if (!fbOrder) {
                console.warn("[KDS] No matching fbOrderData for orderId:", kotOrder.orderId);
                break;
              }

              // 2️⃣ Build lookup map from KOT lines
              const kotStatusMap = new Map();
              kotOrder.line.forEach((line) => {
                if (line?.name) {
                  kotStatusMap.set(line.name.trim(), line.status);
                }
              });

              // 3️⃣ Update cart items
              const updatedCart = {
                ...fbOrder.cart,
                items: fbOrder.cart.items.map((item) => {
                  const newStatus = kotStatusMap.get(item.name?.trim());
                  return newStatus ? { ...item, orderStatus: newStatus } : item;
                }),
              };

              // 3️⃣b Update wsData.items ALSO
              const updatedWsData = fbOrder.wsData
                ? {
                    ...fbOrder.wsData,
                    items: Array.isArray(fbOrder.wsData.items)
                      ? fbOrder.wsData.items.map((item) => {
                          const newStatus = kotStatusMap.get(item.name?.trim());
                          return newStatus ? { ...item, orderStatus: newStatus } : item;
                        })
                      : fbOrder.wsData.items,
                  }
                : fbOrder.wsData;

              // 4️⃣ Persist to Dexie
              await db.fbOrderData.update(fbOrder.id, {
                cart: updatedCart,
                wsData: updatedWsData,
              });

              // 5️⃣ Sync UI cart if same order is open
              const currentCart = JSON.parse(localStorage.getItem("cartObj"));

              if (currentCart?.sOrderID === kotOrder.orderId) {
                const updatedItems = currentCart.items.map((item) => {
                  const newStatus = kotStatusMap.get(item.name?.trim());
                  return newStatus && item.orderStatus !== newStatus ? { ...item, orderStatus: newStatus } : item;
                });

                const nextCart = {
                  ...currentCart,
                  items: updatedItems,
                };

                localStorage.setItem("cartObj", JSON.stringify(nextCart));
                setCart((prev) => ({
                  ...prev,
                  items: updatedItems,
                }));
              }
            } catch (err) {
              console.error("[KDS] NEW_KOT handling failed", err);
            }

            // Show notification to restaurant staff
            // You can customize this based on your notification system
            // const notificationId = `kot_${message.order.id || message.order.fbOrderId}_${Date.now()}`

            // if (!processedTableUpdateIdsRef.current.has(notificationId)) {
            //   console.log("[v0] [HandleMessage] Showing kitchen update notification")

            //   // Add your notification logic here - example:
            //   // toast.info(`Kitchen updated Order #${message.order.id}`);
            //   // or use your custom notification system

            //   processedTableUpdateIdsRef.current.add(notificationId)

            //   // Cleanup old notification IDs
            //   if (processedTableUpdateIdsRef.current.size > 500) {
            //     const entries = Array.from(processedTableUpdateIdsRef.current)
            //     processedTableUpdateIdsRef.current = new Set(entries.slice(-500))
            //   }
            // } else {
            //   console.log("[v0] [HandleMessage] Skipping duplicate NEW_KOT notification")
            // }
          } else {
            console.warn("[v0] [HandleMessage] NEW_KOT message missing order data");
          }
          break;

        case "POS_ORDER_UPSERT":
          if (message && message.data) {
            try {
              // Check if this is a Sales POS (not Waiter)
              const username = localStorage.getItem("username");
              const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
              const matchedRep = salesReps.find((rep) => rep.name === username);

              if (matchedRep) {
                console.log("[POS_ORDER_UPSERT] This is a Waiter POS, skipping order sync logic");
                break;
              }

              console.log("[POS_ORDER_UPSERT] This is a Sales POS, processing order...");

              const serverData = message.data;
              const tillId = tillData.tillAccess.cwrTill.cwrTillID;
              const tillSession = JSON.parse(localStorage.getItem("tillSession") || "{}");
              const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData") || "{}");

              // Check if order already exists (duplicate check)
              const existingOrder = await db.orders.where("sOrderID").equals(serverData.sOrderID).first();

              if (existingOrder) {
                console.log("[POS_ORDER_UPSERT] Order already exists, skipping:", serverData.sOrderID);
                break;
              }

              // Fetch master data
              const allProducts = await db.products.filter((product) => product.isactive === true).toArray();
              const productMap = new Map(allProducts.map((p) => [p.mProductId, p]));

              // Get payment methods from paymentsData
              const openPaymentsData = await db.paymentsData.where("tillStatus").equals("open").first();
              const paymentMethodsList = openPaymentsData?.payments || [];
              const paymentMethodMap = new Map(paymentMethodsList.map((p) => [p.finPaymentmethodId, p]));

              // Helper: Format date DD-MM-YYYY
              const formatDate = (dateStr) => {
                if (!dateStr) return "";
                const date = new Date(dateStr);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
              };

              // Helper: Format datetime DD-MM-YYYY HH:mm:ss
              const formatDateTime = (dateStr) => {
                if (!dateStr) return "";
                const date = new Date(dateStr);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
              };

              // Helper: Convert number to words
              const numberToWords = (num) => {
                const ones = [
                  "",
                  "One",
                  "Two",
                  "Three",
                  "Four",
                  "Five",
                  "Six",
                  "Seven",
                  "Eight",
                  "Nine",
                  "Ten",
                  "Eleven",
                  "Twelve",
                  "Thirteen",
                  "Fourteen",
                  "Fifteen",
                  "Sixteen",
                  "Seventeen",
                  "Eighteen",
                  "Nineteen",
                ];
                const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
                if (num === 0) return "Zero Rupees Only";
                const n = Math.floor(num);
                if (n < 20) return ones[n] + " Rupees Only";
                if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "") + " Rupees Only";
                if (n < 1000) return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " " + numberToWords(n % 100).replace(" Rupees Only", "") : "") + " Rupees Only";
                if (n < 100000)
                  return (
                    numberToWords(Math.floor(n / 1000)).replace(" Rupees Only", "") +
                    " Thousand" +
                    (n % 1000 !== 0 ? " " + numberToWords(n % 1000).replace(" Rupees Only", "") : "") +
                    " Rupees Only"
                  );
                return num + " Rupees Only";
              };

              // Transform items with ALL product keys
              const items = (serverData.line || []).map((line, index) => {
                const product = productMap.get(line.mProductId) || {};
                return {
                  // From product master
                  productId: line.mProductId,
                  name: product.name || line.description || `Product ${index + 1}`,
                  name2: product.name2 || "",
                  value: product.value || line.mProductId,
                  description: product.description || "",
                  imageUrl: product.imageUrl || "",
                  imageurl: product.imageurl || "",
                  hsncode: product.hsncode || null,
                  shortDescription: product.shortDescription || "",
                  upc: product.upc || "",

                  // Tax info
                  tax: line.csTaxId,
                  taxAmount: line.linetax,
                  taxRate: product.taxRate || (line.linenet > 0 ? Math.round((line.linetax / line.linenet) * 100) : 0),
                  taxCategory: product.taxCategory || "",
                  taxName: product.taxName || "",
                  taxFlag: product.taxFlag || "N",
                  unitTax: line.unittax || line.linetax,
                  stdTax: line.linestd || 0,

                  // Price info
                  nettotal: line.linegross || line.linenet + line.linetax,
                  linegross: line.linegross,
                  linenet: line.linenet,
                  linestd: line.linestd,
                  linetax: line.linetax,
                  netunit: line.netunit,
                  listprice: line.listprice,
                  listPrice: line.listprice,
                  grossunit: line.grossunit,
                  grossstd: line.grossstd,
                  grosslist: line.grosslist,
                  unitPrice: line.unitprice,
                  sunitprice: line.unitprice,
                  netList: line.netlist || line.linenet,
                  netStd: line.netstd || line.linenet,
                  originalPrice: line.listprice,
                  realPrice: line.listprice,
                  salePrice: line.listprice,

                  // Quantity
                  weight: line.qty || 1,
                  returnQty: line.returnQty || null,

                  // Product attributes
                  uom: product.uom || line.csUomId,
                  uom_name: product.uom_name || "Pieces",
                  uomData: product.uomData || [],
                  priceList: product.priceList || [],
                  mProductCategoryId: product.mProductCategoryId || "",
                  productCategoryName: product.productCategoryName || "",
                  productBrandId: product.productBrandId || null,
                  productBrandName: product.productBrandName || null,
                  productManufacturerId: product.productManufacturerId || null,
                  productSegment: product.productSegment || "",
                  productionCenter: product.productionCenter || "",
                  productionCenterId: product.productionCenterId || "",
                  itemType: product.itemType || "FGD",
                  type: product.type || "I",
                  foodType: product.foodType || "",

                  // Batch info
                  batchedForSale: product.batchedForSale || "N",
                  batchedForStock: product.batchedForStock || "N",
                  batchedProduct: product.batchedProduct || "N",
                  batchno: line.batchno || null,
                  mBatchId: line.mBatchId || null,

                  // Flags
                  isReturn: line.returnline || false,
                  isDecimal: product.isDecimal || false,
                  isDecimalQty: product.isDecimalQty || false,
                  isManualQty: product.isManualQty || false,
                  isPromoApplicable: product.isPromoApplicable || false,
                  isQtyDesimal: product.isQtyDesimal || 2,
                  multiPrice: product.multiPrice || "N",
                  posPriceEdit: product.posPriceEdit || "N",
                  addNewLine: product.addNewLine || "N",
                  order: product.order || "N",
                  showAddons: product.showAddons || "N",
                  showAlternateUomInPos: product.showAlternateUomInPos || "N",

                  // Discount
                  discount: line.discount || 0,
                  discountName: line.discountName || "",
                  mPricingruleId: line.mPricingruleId || null,
                  upcPricingRule: product.upcPricingRule || null,

                  // Other
                  lineId: line.sOrderlineID,
                  key: index,
                  csBunitId: line.csBunitId || null,
                  bunitName: product.bunitName || "",
                  cwrPcatalogueId: product.cwrPcatalogueId || "",
                  alternateUom: product.alternateUom || null,
                  customAttributes: product.customAttributes || [],
                  newCustomAttributes: product.newCustomAttributes || [],
                  cwrMenuTimeslot: product.cwrMenuTimeslot || [],
                  productAddons: product.productAddons || [],
                  selectedAddons: [],
                  primaryOrderLine: line.primaryOrderLine || null,
                  printerId: product.printerId || "",
                  preparationTime: product.preparationTime || "",
                  shelfLife: product.shelfLife || "",
                  stock: product.stock || 0,
                  salesRepId: line.salesRepId || null,
                  salesRepName: line.salesRepName || "",
                  saleType: saleTypeData?.value || "",
                };
              });

              // Transform payments with ALL payment method keys
              const payments = (serverData.payments || []).map((payment) => {
                const matchedMethod = paymentMethodMap.get(payment.finPaymentmethodID);
                return {
                  // From payment method master
                  finPaymentmethodId: payment.finPaymentmethodID,
                  cWRPaymentMethodID: matchedMethod?.cWRPaymentMethodID || "",
                  name: matchedMethod?.name || "Cash",
                  cwrTillId: tillId,
                  finFinancialAccountId: matchedMethod?.finFinancialAccountId || "",
                  finDayCloseAccountId: matchedMethod?.finDayCloseAccountId || null,
                  csCurrencyId: matchedMethod?.csCurrencyId || null,
                  isoCode: matchedMethod?.isoCode || null,
                  isDefault: matchedMethod?.isDefault || "N",
                  isactive: matchedMethod?.isactive ?? true,
                  integratedPayment: matchedMethod?.integratedPayment || false,
                  paymentProvider: matchedMethod?.paymentProvider || null,
                  paymentProviderDetails: matchedMethod?.paymentProviderDetails || null,
                  roundOffForPos: matchedMethod?.roundOffForPos || "Y",
                  sequenceNo: matchedMethod?.sequenceNo || null,
                  salesType: matchedMethod?.salesType || [],
                  saleTypeId: matchedMethod?.saleTypeId || null,
                  saleTypeName: matchedMethod?.saleTypeName || null,

                  // Flags
                  iscredit: matchedMethod?.iscredit || false,
                  isloyalty: matchedMethod?.isloyalty || false,
                  isGiftCard: matchedMethod?.isGiftCard || false,
                  isGiftVoucher: matchedMethod?.isGiftVoucher || false,
                  isCreditNote: matchedMethod?.isCreditNote || false,

                  // Amount
                  amount: String(payment.amount),
                };
              });

              // Transform taxDetails
              const taxDetails = (serverData.tax || []).map((t) => {
                const matchedProduct = allProducts.find((p) => p.cTaxId === t.csTaxID);
                return {
                  csTaxID: t.csTaxID,
                  taxableAmt: t.taxableAmt,
                  taxAmt: t.taxAmt,
                  taxRate: matchedProduct?.taxRate?.toString() || (t.taxableAmt > 0 ? String(Math.round((t.taxAmt / t.taxableAmt) * 100)) : "0"),
                  taxCategory: matchedProduct?.taxCategory || "",
                  taxName: matchedProduct?.taxName || "",
                };
              });

              // Build customer object with ALL keys
              const customer = {
                b2cCustomerId: serverData.cwrB2cCustomerId || "",
                cwrCustomerId: serverData.cwrB2cCustomerId || "",
                b2cRegisteredstoreId: "0",
                code: "",
                name: "",
                email: null,
                mobileNo: null,
                pincode: 0,
                iscredit: false,
                balancePoints: null,
                retlLoyaltyBalance: 0,
                priceListName: null,
                sPriceListId: null,
                sCustomer: {
                  sCustomerID: serverData.sCustomerId || "",
                },
                sCustomerId: serverData.sCustomerId || "",
                sCustomerBillingId: serverData.sCustomerBillingId || "",
                sCustomerShippingId: serverData.sCustomerShippingId || "",
              };

              // Build saleType object with ALL keys
              const saleType = {
                cwrSaletypeId: serverData.cwrSaletypeId || saleTypeData?.cwrSaletypeId || "",
                value: saleTypeData?.value || "",
                name: saleTypeData?.name || "",
                isdefault: saleTypeData?.isdefault || "N",
                colourCode: saleTypeData?.colourCode || "",
                enableKot: saleTypeData?.enableKot || "N",
                enableLayaway: saleTypeData?.enableLayaway || "N",
              };

              // Determine if return
              const isReturn = serverData.isReturn === "Y" || serverData.isReturn === true;

              // Build cartToDb with ALL required keys
              const cartToDb = {
                // Spread serverData first to keep original keys
                ...serverData,

                // Transformed arrays
                items,
                payments,
                taxDetails,
                combinedTaxRates: serverData.tax || [],

                // Core totals
                total: serverData.orderTotal,
                tax: serverData.taxamt,
                paid: serverData.orderTotal,
                tenderedAmount: serverData.orderTotal,
                subTotal: serverData.nettotal || 0,
                totalStd: serverData.orderTotal,
                totalQty: serverData.cwrProductQty || items.length,

                // Renamed fields from serverData
                accumulationPoints: serverData.accumulation || 0,
                redemptionPoints: serverData.redemption || 0,
                discount: serverData.discAmount || 0,
                roundOff: serverData.roundoff || 0,
                creditAmount: parseFloat(serverData.creditAmount) || 0,
                createdBy: serverData.createdby || "",

                // Date/Time fields
                orderDate: formatDate(serverData.dateordered),
                orderTime: formatDateTime(serverData.created),
                orderTimeDetails: {
                  orderStartTime: formatDateTime(serverData.created),
                  orderEndTime: formatDateTime(serverData.updated),
                  paymentStartTime: formatDateTime(serverData.created),
                },

                // Objects
                customer,
                saleType,

                // Session/Till info from Sales POS
                tillSessionId: tillSession.tillSessionId || "",
                tillName: tillData?.tillAccess?.cwrTill?.till || "",
                userName: username || "",

                // Status fields
                isReturn,
                docType: isReturn ? "Return" : "Invoice",
                orderCompleted: true,
                isSynced: 1,
                syncAttempts: 0,

                // Additional required fields
                key: serverData.sOrderID,
                orderType: serverData.cwrSaletypeId || saleTypeData?.cwrSaletypeId || "",
                referenceId: serverData.redeemRefId || serverData.creditReferenceNo || "",
                couponRefId: serverData.creditReferenceNo || "",
                giftCardRefId: "",
                amountInWords: numberToWords(serverData.orderTotal),

                // Flags
                dineIn: "N",
                layAway: serverData.layAway || "N",
                statusType: "N",
                typeOrder: "N",
                iscoupon: false,
                totalBillDicount: false,
                totalDiscountFlag: serverData.discAmount > 0,

                // Payment related
                overPayedAmount: 0,
                advancePayment: 0,
                change: 0,

                // Empty arrays/objects
                cardPaymentData: {},
                couponInput: [],
                giftCardData: [],
                groupedItemsByTaxRate: {},
                itemsSummery: {},

                // Customer search
                customerSearchKey: customer.code || "",
              };

              // Parse change from metaData
              const paymentDetails = serverData.metaData?.find((m) => m.key === "Payment Details");
              if (paymentDetails?.value) {
                try {
                  const paymentArr = JSON.parse(paymentDetails.value);
                  const changeObj = paymentArr.find((p) => p.hasOwnProperty("change"));
                  cartToDb.change = changeObj?.change || 0;
                } catch (e) {
                  cartToDb.change = 0;
                }
              }

              console.log("[POS_ORDER_UPSERT] Transformed cartToDb:", cartToDb);

              // 1. Add to db.orders
              await db.orders.add({ ...cartToDb, isSynced: 1 });
              console.log("[POS_ORDER_UPSERT] Added new order:", cartToDb.sOrderID);

              // 2. Update db.ordersData where tillStatus = "open"
              await db.ordersData
                .where("tillStatus")
                .equals("open")
                .modify((existingData) => {
                  // Process items - aggregate by value (product code)
                  for (const item of cartToDb.items) {
                    const index = existingData.items.findIndex((ele) => ele.value === item.value);
                    if (index >= 0) {
                      existingData.items[index].taxAmount = +parseFloat((existingData.items[index].taxAmount + (item.taxAmount || 0)).toFixed(precision));
                      existingData.items[index].nettotal = +parseFloat((existingData.items[index].nettotal + (item.nettotal || 0)).toFixed(precision));
                      existingData.items[index].weight = parseFloat((parseFloat(existingData.items[index].weight) + parseFloat(item.weight || 0)).toFixed(2));
                    } else {
                      existingData.items.push({
                        taxAmount: +parseFloat((item.taxAmount || 0).toFixed(precision)),
                        nettotal: +parseFloat((item.nettotal || 0).toFixed(precision)),
                        weight: parseFloat((item.weight || 0).toFixed(2)),
                        value: item.value,
                        name: item.name,
                      });
                    }
                  }

                  // Process tax details
                  const targetTaxArray = isReturn ? existingData.returnTax : existingData.salesTax;

                  for (const newTax of cartToDb.taxDetails || []) {
                    const existingTax = targetTaxArray.find((tax) => tax.taxRate === newTax.taxRate);
                    if (existingTax) {
                      existingTax.taxAmt = +parseFloat((existingTax.taxAmt + (newTax.taxAmt || 0)).toFixed(precision));
                      existingTax.taxableAmt = +parseFloat((existingTax.taxableAmt + (newTax.taxableAmt || 0)).toFixed(precision));
                    } else {
                      targetTaxArray.push({
                        csTaxID: newTax.csTaxID,
                        taxableAmt: parseFloat((newTax.taxableAmt || 0).toFixed(precision)),
                        taxAmt: parseFloat((newTax.taxAmt || 0).toFixed(precision)),
                        taxRate: newTax.taxRate,
                        taxCategory: newTax.taxCategory,
                        taxName: newTax.taxName,
                      });
                    }
                  }

                  // Update totals
                  if (isReturn) {
                    existingData.netReturnTotal = +parseFloat(((existingData.netReturnTotal || 0) + Math.abs(cartToDb.total - cartToDb.tax)).toFixed(precision));
                    existingData.grossReturnTotal = +parseFloat(((existingData.grossReturnTotal || 0) + Math.abs(cartToDb.total)).toFixed(precision));
                    existingData.totaReturnlTax = +parseFloat(((existingData.totaReturnlTax || 0) + Math.abs(cartToDb.tax)).toFixed(precision));
                    existingData.returnsTransactions = (existingData.returnsTransactions || 0) + 1;
                  } else {
                    existingData.netTotal = +parseFloat(((existingData.netTotal || 0) + (cartToDb.total - cartToDb.tax)).toFixed(precision));
                    existingData.grossTotal = +parseFloat(((existingData.grossTotal || 0) + cartToDb.total).toFixed(precision));
                    existingData.totalTax = +parseFloat(((existingData.totalTax || 0) + cartToDb.tax).toFixed(precision));
                    existingData.salesTransactions = (existingData.salesTransactions || 0) + 1;
                  }
                });

              // 3. Update db.paymentsData where tillStatus = "open"
              await db.paymentsData
                .where("tillStatus")
                .equals("open")
                .modify((event) => {
                  const filteredPayments = event.payments.filter((payment) => payment?.cwrTillId === tillId);

                  for (const payment of filteredPayments) {
                    let currPaymentAmount = 0;
                    let currPaymentReturn = 0;

                    for (const orderPayment of cartToDb.payments || []) {
                      if (payment.finPaymentmethodId === orderPayment.finPaymentmethodId) {
                        if (cartToDb.total > 0) {
                          currPaymentAmount += parseFloat(orderPayment.amount);
                          payment.transactionCount = (payment.transactionCount || 0) + 1;
                        } else if (cartToDb.total < 0) {
                          currPaymentReturn += parseFloat(Math.abs(orderPayment.amount));
                          payment.transactionCount = (payment.transactionCount || 0) + 1;
                        }
                      }
                    }

                    payment.expectedAmount = (payment.expectedAmount || 0) + currPaymentAmount;
                    payment.amount = (payment.amount || 0) + currPaymentAmount;
                    payment.paymentReturn = (payment.paymentReturn || 0) + currPaymentReturn;
                    payment.difference = (payment.difference || 0) + payment.expectedAmount;
                    payment.change = (payment.change || 0) + (cartToDb.change || 0);
                  }

                  event.payments = filteredPayments;
                });

              console.log("[POS_ORDER_UPSERT] Successfully processed waiter order:", serverData.documentno);
            } catch (err) {
              console.error("[POS_ORDER_UPSERT] Error processing order:", err);
            }
          } else {
            console.warn("[HandleMessage] POS_ORDER_UPSERT message missing order data");
          }
          break;

        case "MISSED_EVENTS_COMPLETE":
          console.log(`[v0] [HandleMessage] Missed table status events sync complete. Total: ${message.count}`);
          break;

        case "REDIS_RECONNECTED":
          console.log("[v0] [HandleMessage] Redis reconnected - table status will sync automatically");
          break;

        case "ERROR":
          console.error("[v0] [HandleMessage] WebSocket error message:", message.error || message.message);
          break;

        default:
          console.log("[v0] [HandleMessage] Unknown message type:", message.type);
      }
    } catch (error) {
      console.error("[v0] [HandleMessage] Error handling WebSocket message:", error);
      console.error("[v0] [HandleMessage] Stack trace:", error.stack);
    }

    console.log("[v0] [HandleMessage] ========== MESSAGE PROCESSING DONE ==========");
  }, []);

  const {} = useRestaurantWebSocket({
    url: process.env.REACT_APP_WS_URL || "ws://localhost:8080",
    bunitId: tillData.tillAccess.csBunit.csBunitId,
    enabled: tillData.tillAccess.csBunit.csBunitId,
    onMessage: handleWebSocketMessage,
    onConnect: () => {
      console.log("[v0] WebSocket connected successfully");
      console.log("[v0] - URL:", process.env.REACT_APP_WS_URL || "ws://localhost:8080");
    },
    onDisconnect: () => {
      console.log("[v0] WebSocket disconnected");
    },
    onError: (error) => {
      console.error("[v0] WebSocket error:", error);
    },
  });

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#fff" }} spin />} spinning={false}>
      {syncLoad ? (
        <>
          <div style={{ backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%" }}>
            <Row style={{ height: "9vh", background: "", padding: "0.8% 0" }}>
              <Col span={6}>
                <img src={Logo} style={{ height: "2.8vw", paddingLeft: "1vw", paddingTop: "1vh" }} />
              </Col>
              <Col span={18} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "1vw", fontSize: "1vw" }}>
                <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{formattedDateTime}</div>
                <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{clock1}</div>
              </Col>
            </Row>
            <div style={{ display: "flex", height: "90vh" }}>
              <div
                style={{
                  width: "48%",
                  background: "#fff",
                  height: "83vh",
                  margin: "1.5%",
                  marginRight: 0,
                  borderRadius: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "1vw" }}>
                  <div style={{ position: "relative", width: "13vw", height: "13vw" }}>
                    <img
                      src={leftLoading}
                      alt="Loading"
                      style={{
                        width: "100%",
                        height: "100%",
                        // transform: `rotate(${rotation}deg)`,
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "1.5em",
                        fontWeight: "500",
                        color: "#0F0718",
                      }}
                    >
                      {percent}
                    </div>
                  </div>
                  <p style={{ color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "2.5em", marginBottom: 0 }}>Till loading in process</p>
                  {/* <p style={{color:"#D73A48",fontFamily:"Inter",fontWeight:500,fontSize:"1.5vw",marginBottom:0}}>{formatTime(time)}</p>
           <p style={{color:"#0F0718",fontFamily:"Inter",fontWeight:500,fontSize:"1.5vw"}}>Minutes Left</p> */}
                </div>
              </div>
              <div style={{ width: "48%", height: "83vh", background: "#fff", margin: "1.5%", borderRadius: "10px", color: "#0F0718" }}>
                <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "17vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>
                  Product Categories
                </p>
                <Progress
                  strokeColor={{
                    from: "#2F3856",
                    to: "#2F3856",
                  }}
                  // showInfo={false}
                  style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
                  percent={productCategoryPercentage}
                  status="active"
                />
                <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Products</p>
                <Progress
                  strokeColor={{
                    from: "#2F3856",
                    to: "#2F3856",
                  }}
                  // showInfo={false}
                  style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
                  percent={productPercentage}
                  status="active"
                />
                <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Promotions</p>
                <Progress
                  strokeColor={{
                    from: "#2F3856",
                    to: "#2F3856",
                  }}
                  // showInfo={false}
                  style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
                  percent={promotionPercentage}
                  status="active"
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div style={data.posScreenStyles.main}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                backgroundColor: "#fff",
                height: "100vh",
                width: "6.7%",
                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.15)",
                paddingLeft: "0.5vw",
                paddingRight: "0.5vw",
                display: showOrderCompleteFlag ? "none" : "",
              }}
            >
              <Row style={{ fontSize: "1vw" }}>
                <Col span={24} style={{ marginTop: "1.4vh" }}>
                  <Tooltip>
                    <button
                      style={{
                        width: "100%",
                        background: "#fff",
                        color: "#ffffff",
                        border: "1px solid #fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={Logo} alt="remove" style={{ height: "4.5vw" }} />
                    </button>
                  </Tooltip>
                </Col>
                <Scrollbars autoHide style={{ height: "78vh" }}>
                  {!showMoreMenu ? (
                    <>
                      {sortedSaleTypes?.map((saleType, index) => {
                        const fulfilmentType = saleType?.cwrSaletype?.fulfilmentType;
                        const isSelected =
                          selectedSaleTypeIndex !== null
                            ? selectedSaleTypeIndex === index
                            : fulfilmentType === defaultFulfilmentType && sortedSaleTypes.findIndex((st) => st?.cwrSaletype?.fulfilmentType === defaultFulfilmentType) === index;
                        const FulfilmentIcon = fulfilmentIconMap[saleType?.cwrSaletype?.fulfilmentType] || TableDineIN;
                        return (
                          <Col
                            key={index}
                            id="step1"
                            span={24}
                            style={{
                              marginTop: "0.7vh",
                              display: posConfig?.enableDineIn === "Y" || posConfig?.enableTakeAway === "Y" || posConfig?.enableHomeDelivery === "Y" ? "block" : "none",
                            }}
                          >
                            <button
                              className="cartMenuItems"
                              style={{
                                display: saleType?.cwrSaletype?.fulfilmentType === "DI" ? (tillaccess?.dineIn === "Y" ? "block" : "none") : "block",
                                ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                                // display: accessController?.=== "N" ? "block" : "none",
                                // ...(keyValue === "0"
                                ...(isSelected
                                  ? {
                                      backgroundColor: "#2F3856",
                                      border: "1px solid #2F3856",
                                    }
                                  : { backgroundColor: "#fff", border: "1px solid #fff" }),
                              }}
                              onClick={async () => {
                                if (cart.paid > 0) {
                                  message.warning(`${messages.errors.till_management.delete_payment_method}`);
                                  return;
                                }
                                if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                                  message.warning(`${messages.errors.cart.cart_switch_section}`);
                                  return;
                                }
                                if (showSendToKitchen && hasUnfiredItems) {
                                  message.warning(`${messages.errors.cart.cart_switch_section}`);
                                  return;
                                }
                                if (splitBillScreen) {
                                  message.warning(messages.errors.cart.cart_switch_section);
                                  return;
                                }
                                if (fulfilmentType === "TA") {
                                  setCart(clearCartData);
                                  localStorage.setItem("cartObj", JSON.stringify(clearCartData));
                                }
                                setSelectedSaleTypeIndex(index);
                                setShowProducts(false);
                                // const selectedSaleTypeArray = await getSaleTypeArray("DI");
                                // handleSelectedSaleTypeForProducts(selectedSaleTypeArray)();
                                await handleSelectedSaleTypeForProducts(saleType)();
                                const cartObj = JSON.parse(localStorage.getItem("cartObj"));
                                let updatedCart = {
                                  ...cartObj,
                                  customer: saleType.customer?.b2cCustomerId ? saleType.customer : tillData.tillAccess.csBunit.b2cCustomer,
                                  sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                                  saleType: saleType?.cwrSaletype ?? {},
                                };
                                setCart(updatedCart);
                                localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                                // setSaleType("DI");
                                setSaleType(fulfilmentType);
                                // handleKeyvalue("0");
                                handleKeyvalue({ DI: "0", DE: "1", TA: "2" }[saleType?.cwrSaletype?.fulfilmentType], fulfilmentType);
                                setPaymentVisible(false);
                                setShowProducts(false);
                                // setSaleTypeProducts([]);
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "column",
                                }}
                              >
                                <FulfilmentIcon color={isSelected ? "#FFF" : "#555359"} />
                                <span
                                  className="posIcon"
                                  style={{
                                    // color: keyValue === "0" ? "#fff" : "#555359",
                                    // color: "#fff",
                                    color: isSelected ? "#fff" : "#555359",
                                    fontWeight: 500,
                                  }}
                                >
                                  {/* {getMultilingualText("Dine In")} */}
                                  {saleType?.cwrSaletype?.name}
                                </span>
                              </div>
                            </button>
                          </Col>
                        );
                      })}

                      {/* RESERVATIONS BUTTON */}
                      <Col
                        id="reservations"
                        span={24}
                        style={{ marginTop: "1vh", display: "block" }} // always show
                      >
                        <button
                          className="cartMenuItems"
                          style={{
                            ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                            ...(keyValue === "4" // highlight when selected
                              ? {
                                  backgroundColor: "#2F3856",
                                  border: "1px solid #2F3856",
                                }
                              : {
                                  backgroundColor: "#fff",
                                  border: "1px solid #fff",
                                }),
                          }}
                          onClick={async () => {
                            if (cart.paid > 0) {
                              message.warning(`${messages.errors.till_management.delete_payment_method}`);
                              return;
                            }
                            if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (showSendToKitchen && hasUnfiredItems) {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (splitBillScreen) {
                              message.warning(messages.errors.cart.cart_switch_section);
                              return;
                            }
                            setSelectedSaleTypeIndex(10);
                            // Set active button
                            handleKeyvalue("4");
                            setReservationsBlank(true);
                            loadReservations();
                            const list = await loadWaitlistForUI(); // get data
                            setWaitlistList(list);
                            // Your reservation page logic
                            // Example:
                            //history.push("/reservations");
                            // Or open your guest modal:
                            // setGuestsModalFlag(true)
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            {/* Use any icon you want */}
                            <TableMenu color={keyValue === "4" ? "#FFF" : "#555359"} />

                            <span style={{ color: keyValue === "4" ? "#fff" : "#555359", fontSize: "10px" }}>{getMultilingualText("Reservations")}</span>
                          </div>
                        </button>
                      </Col>
                      {posConfig?.enablePreOrder === "Y" && (
                        <Col
                          id="reservations"
                          span={24}
                          style={{ marginTop: "1vh", display: "block" }} // always show
                        >
                          <button
                            className="cartMenuItems"
                            style={{
                              ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                              backgroundColor: "#fff",
                              border: "1px solid #fff",
                            }}
                            onClick={async () => {
                              if (cart.paid > 0) {
                                message.warning(`${messages.errors.till_management.delete_payment_method}`);
                                return;
                              }
                              if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                                message.warning(`${messages.errors.cart.cart_switch_section}`);
                                return;
                              }
                              if (showSendToKitchen && hasUnfiredItems) {
                                message.warning(`${messages.errors.cart.cart_switch_section}`);
                                return;
                              }
                              if (splitBillScreen) {
                                message.warning(messages.errors.cart.cart_switch_section);
                                return;
                              }
                              history.push("/restaurant/preorder");
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              {/* Use any icon you want */}
                              <TableMenu color={"#555359"} />

                              <span style={{ color: "#555359", fontSize: "10px" }}>{getMultilingualText("Pre-Order")}</span>
                            </div>
                          </button>
                        </Col>
                      )}
                      {posConfig?.enableAggregator === "Y" && (
                        <Col id="aggregator" span={24}>
                          <button
                            className="cartMenuItems"
                            style={{
                              backgroundColor: "#fff",
                              border: "1px solid #fff",
                            }}
                            onClick={() => {
                              history.push("/aggregator");
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                              <img src={openDrawerIcon} style={{ height: "3vh" }} alt="" />
                              <span className="posIcon" style={{ color: "#555359" }}>
                                Aggregator
                              </span>
                            </div>
                          </button>
                        </Col>
                      )}
                      {!multilingual && (
                        <Col id="step5" span={24} style={{ marginTop: "2vh" }}>
                          <button
                            className="cartMenuItems"
                            style={{
                              ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                              ...(keyValue === "6"
                                ? {
                                    backgroundColor: "#2F3856",
                                    border: "1px solid #2F3856",
                                    padding: "0",
                                  }
                                : {
                                    backgroundColor: "#fff",
                                    border: "1px solid #fff",
                                    padding: "0",
                                  }),
                            }}
                            onClick={async () => {
                              const tables = await db.tableData.toArray();
                              const hasPendingBill = tables.some((table) => table.statusType === "OCU");

                              if (hasPendingBill) {
                                message.warning("Please complete the bill to proceed to Product sync", { duration: 10 });
                                return;
                              }
                              if (cart.paid > 0) {
                                message.warning(`${messages.errors.till_management.delete_payment_method}`);
                                return;
                              }
                              if (cart.items.length > 0 && (showProducts || keyValue === "2")) {
                                message.warning(`${messages.errors.cart.cart_switch_section}`);
                                return;
                              }
                              if (showSendToKitchen && hasUnfiredItems) {
                                message.warning(`${messages.errors.cart.cart_switch_section}`);
                                return;
                              }
                              if (splitBillScreen) {
                                message.warning(messages.errors.cart.cart_switch_section);
                                return;
                              }
                              handleKeyvalue("6");
                              setSyncLoad(true);
                              localStorage.removeItem("lastUpdatedTime");
                              let tillData = JSON.parse(localStorage.getItem("tillData"));
                              await processSync(tillData, setGlobalStore, "Incremental Sync");
                              setSyncLoad(false);
                              setGlobalStore({ percent: "0%" });
                              setGlobalStore({ productCategoryPercentage: "0" });
                              setGlobalStore({ productPercentage: "0" });
                              setGlobalStore({ promotionPercentage: "0" });
                              window.location.reload();
                              setKeyValue("0");
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              <SyncIcon color={keyValue === "6" ? "#FFF" : "#555359"} />
                              <span className="posMenuIcons" style={{ color: keyValue === "6" ? "#fff" : "#555359" }}>
                                {getMultilingualText("Product Sync")}
                              </span>
                            </div>
                          </button>
                        </Col>
                      )}
                      <Col id="step4" span={24} style={{ marginTop: "1vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                            ...(keyValue === "3"
                              ? {
                                  backgroundColor: "#2F3856",
                                  border: "1px solid #2F3856",
                                  padding: "0",
                                }
                              : {
                                  backgroundColor: "#fff",
                                  border: "1px solid #fff",
                                  padding: "0",
                                }),
                          }}
                          onClick={async () => {
                            setLoading(true); // Show loader immediately

                            try {
                              if (cart.paid > 0) {
                                message.warning(`${messages.errors.till_management.delete_payment_method}`);
                                return;
                              }
                              if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                                message.warning(`${messages.errors.cart.cart_switch_section}`);
                                return;
                              }
                              if (showSendToKitchen && hasUnfiredItems) {
                                message.warning(`${messages.errors.cart.cart_switch_section}`);
                                return;
                              }
                              if (splitBillScreen) {
                                message.warning(messages.errors.cart.cart_switch_section);
                                return;
                              }
                              setSelectedSaleTypeIndex(10);
                              handleKeyvalue("3");
                              setShowOrderCompleteFlag(false);
                              // deleteCart();
                              setPaymentVisible(false);
                              setShowProducts(false);
                              setSaleTypeProducts([]);
                              setCart(clearCartData);
                              localStorage.setItem("cartObj", JSON.stringify(clearCartData));
                              setSearchhistoryInput("");
                              setOrderHistoryDetails([]);
                              setFiltersFlag(false);
                              const dateValue = [moment(new Date()), moment(new Date())];
                              setOrderHistoryDetails([]);

                              // Await if searchOrderHistory is async
                              await searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true);
                            } catch (error) {
                              console.error("Error processing click:", error);
                            } finally {
                              setLoading(false);
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <TableOrder color={keyValue === "3" ? "#FFF" : "#fff"} />
                            <span className="posIcon" style={{ color: keyValue === "3" ? "#fff" : "#555359" }}>
                              {getMultilingualText("History")}
                            </span>
                          </div>
                        </button>

                        {loading && (
                          <div
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100vw",
                              height: "100vh",
                              backgroundColor: "rgba(0, 0, 0, 0.3)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              zIndex: 10000,
                            }}
                          >
                            <Spin size="large" />
                          </div>
                        )}
                      </Col>

                      <Col id="moreMenuButton" span={24} style={{ marginTop: "1vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #fff",
                          }}
                          onClick={() => {
                            if (cart.paid > 0) {
                              message.warning(`${messages.errors.till_management.delete_payment_method}`);
                              return;
                            }
                            if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (showSendToKitchen && hasUnfiredItems) {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (splitBillScreen) {
                              message.warning(messages.errors.cart.cart_switch_section);
                              return;
                            }
                            setShowMoreMenu(!showMoreMenu);
                            //  setKeyValue("0");
                          }}
                        >
                          <div>
                            <MoreOutlined style={{ color: "#555359" }} />
                            {/* <span className="posIcon" style={{ color: "#555359" }}>...</span> */}
                          </div>
                        </button>
                      </Col>
                    </>
                  ) : (
                    <>
                      {multilingual && (
                        <Col id="step5" span={24} style={{ marginTop: "1.5vh" }}>
                          <button
                            className="cartMenuItems"
                            style={{
                              ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                              ...(keyValue === "6"
                                ? {
                                    backgroundColor: "#2F3856",
                                    border: "1px solid #2F3856",
                                    padding: "0",
                                  }
                                : {
                                    backgroundColor: "#fff",
                                    border: "1px solid #fff",
                                    padding: "0",
                                  }),
                            }}
                            onClick={async () => {
                              if (cart.paid > 0) {
                                message.warning(`${messages.errors.till_management.delete_payment_method}`);
                                return;
                              }
                              if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                                message.warning(`${messages.errors.cart.cart_switch_section}`);
                                return;
                              }
                              if (showSendToKitchen && hasUnfiredItems) {
                                message.warning(`${messages.errors.cart.cart_switch_section}`);
                                return;
                              }
                              handleKeyvalue("6");
                              setSyncLoad(true);
                              localStorage.removeItem("lastUpdatedTime");
                              let tillData = JSON.parse(localStorage.getItem("tillData"));
                              await processSync(tillData, setGlobalStore, "Incremental Sync");
                              setSyncLoad(false);
                              setGlobalStore({ percent: "0%" });
                              setGlobalStore({ productCategoryPercentage: "0" });
                              setGlobalStore({ productPercentage: "0" });
                              setGlobalStore({ promotionPercentage: "0" });
                              window.location.reload();
                              setKeyValue("0");
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              <SyncIcon color={keyValue === "6" ? "#FFF" : "#555359"} />
                              <span className="posMenuIcons" style={{ color: keyValue === "6" ? "#fff" : "#555359" }}>
                                {getMultilingualText("Product Sync")}
                              </span>
                            </div>
                          </button>
                        </Col>
                      )}

                      <Col id="unlinkTill" span={24} style={{ marginTop: "2vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                            ...(isUnlinkTillClicked
                              ? {
                                  backgroundColor: "#2F3856", // Active background color
                                  border: "1px solid #2F3856",
                                }
                              : {
                                  backgroundColor: "#fff", // Default background color
                                  border: "1px solid #fff",
                                }),
                          }}
                          onClick={handleUnlinkTillClick}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <img
                              src={unlinkTill}
                              style={{
                                height: "3vh",
                                filter: isUnlinkTillClicked
                                  ? "brightness(0) invert(1)" // Makes the icon white when clicked
                                  : "none", // Default icon color
                              }}
                              alt="unlink till"
                            />
                            <span
                              className="posMenuIcons"
                              style={{
                                color: isUnlinkTillClicked ? "#fff" : "#555359", // White text color when clicked, default otherwise
                              }}
                            >
                              {getMultilingualText("Unlink Till")}
                            </span>
                          </div>
                        </button>
                      </Col>

                      <Col id="step5" span={24} style={{ marginTop: "0.5vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                            ...(keyValue === "6"
                              ? {
                                  backgroundColor: "#2F3856",
                                  border: "1px solid #2F3856",
                                  padding: "0",
                                }
                              : {
                                  backgroundColor: "#fff",
                                  border: "1px solid #fff",
                                  padding: "0",
                                }),
                          }}
                          onClick={async () => {
                            const tables = await db.tableData.toArray();
                            const hasPendingBill = tables.some((table) => table.statusType === "OCU");

                            if (hasPendingBill) {
                              message.warning("Please complete the bill to proceed to Full sync", { duration: 10 });
                              return;
                            }
                            if (cart.paid > 0) {
                              message.warning(`${messages.errors.till_management.delete_payment_method}`);
                              return;
                            }
                            if (cart.items.length > 0 && (showProducts || keyValue === "2")) {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (showSendToKitchen && hasUnfiredItems) {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            handleKeyvalue("6");
                            setSyncLoad(true);
                            localStorage.removeItem("lastUpdatedTime");
                            let tillData = JSON.parse(localStorage.getItem("tillData"));
                            await processSync(tillData, setGlobalStore, "Full Sync");
                            setSyncLoad(false);
                            setGlobalStore({ percent: "0%" });
                            setGlobalStore({ productCategoryPercentage: "0" });
                            setGlobalStore({ productPercentage: "0" });
                            setGlobalStore({ promotionPercentage: "0" });
                            window.location.reload();
                            setKeyValue("0");
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <SyncIcon color={keyValue === "6" ? "#FFF" : "#555359"} />
                            <span className="posMenuIcons" style={{ color: keyValue === "6" ? "#fff" : "#555359" }}>
                              {getMultilingualText("Full Sync")}
                            </span>
                          </div>
                        </button>
                      </Col>

                      {/* <Col id="printReceipt" span={24} style={{ marginTop: "2vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                          <img src={printerIcon} style={{ height: "3vh" }} alt="" />
                          <span className="posIcon" style={{ color: "#555359" }}>
                            {getMultilingualText("Print")}{" "}
                          </span>
                        </div>
                      </button>
                    </Col> */}
                      <Col id="step4" span={24} style={{ marginTop: "0.5vh", display: posConfig?.showCustomers === "Y" ? "block" : "none" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                            ...(keyValue === "8"
                              ? {
                                  backgroundColor: "#2F3856",
                                  border: "1px solid #2F3856",
                                  padding: "0",
                                }
                              : {
                                  backgroundColor: "#fff",
                                  border: "1px solid #fff",
                                  padding: "0",
                                }),
                          }}
                          onClick={() => {
                            if (cart.paid > 0) {
                              message.warning(`${messages.errors.till_management.delete_payment_method}`);
                              return;
                            }
                            if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (showSendToKitchen && hasUnfiredItems) {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (splitBillScreen) {
                              message.warning(messages.errors.cart.cart_switch_section);
                              return;
                            }
                            handleKeyvalue("8");
                            setPaymentVisible(false);
                            setShowProducts(false);
                            setSaleTypeProducts([]);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <TableCustomer color={keyValue === "8" ? "#FFF" : "#555359"} />
                            <span className="posIcon" style={{ color: keyValue === "8" ? "#fff" : "#555359" }}>
                              {getMultilingualText("Customers")}
                            </span>
                          </div>
                        </button>
                      </Col>
                      <Col id="step3" span={24} style={{ marginTop: "3.5vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                            ...(keyValue === "5"
                              ? {
                                  backgroundColor: "#2F3856",
                                  border: "1px solid #2F3856",
                                  padding: "0",
                                }
                              : {
                                  backgroundColor: "#fff",
                                  border: "1px solid #fff",
                                  padding: "0",
                                }),
                          }}
                          onClick={() => {
                            if (cart.paid > 0) {
                              message.warning(`${messages.errors.till_management.delete_payment_method}`);
                              return;
                            }
                            if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (showSendToKitchen && hasUnfiredItems) {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (splitBillScreen) {
                              message.warning(messages.errors.cart.cart_switch_section);
                              return;
                            }
                            handleKeyvalue("5");
                            setPaymentVisible(false);
                            setShowProducts(false);
                            setSaleTypeProducts([]);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <CashManagementIcon color={keyValue === "5" ? "#FFF" : "#555359"} />
                            <span
                              className="posMenuIcons"
                              style={{
                                color: keyValue === "5" ? "#fff" : "#555359",
                                paddingTop: "0px",
                              }}
                            >
                              {getMultilingualText("Cash Management")}
                            </span>
                          </div>
                        </button>
                      </Col>
                      <Col
                        id="salesReport"
                        span={24}
                        onClick={async () => {
                          try {
                            let ordersData = await db.ordersData.toArray();
                            ordersData = ordersData.filter((data) => data.tillStatus === "open");

                            if (CWHardwareController && typeof salesReportCWHCPrinter === "function") {
                              await salesReportCWHCPrinter(ordersData);
                            } else if (typeof salesReportPrinter === "function") {
                              await salesReportPrinter(ordersData);
                            } else {
                              console.error("Sales report printer functions not found");
                            }
                          } catch (err) {
                            console.error("Error while printing sales report:", err);
                          }
                        }}
                        style={{
                          cursor: "pointer",
                          display: tillData?.tillAccess?.salesReport === "Y" ? "block" : "none",
                          marginTop: "2vh",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #fff",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <img src={salesReportIcon} style={{ height: "3vh" }} alt="sales report" />
                            <span className="posIcon" style={{ color: "#555359" }}>
                              {getMultilingualText("Sales Report")}
                            </span>
                          </div>
                        </button>
                      </Col>
                      {posConfig?.enableCallCentre === "Y" && (
                        <Col span={24} style={{ marginTop: "0.5vh", display: "block" }}>
                          <button
                            className="cartMenuItems"
                            style={{
                              ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                              ...(keyValue === "9"
                                ? { backgroundColor: "#2F3856", border: "1px solid #2F3856", padding: "0" }
                                : { backgroundColor: "#fff", border: "1px solid #fff", padding: "0" }),
                            }}
                            onClick={async () => {
                              try {
                                // ----- 1. Guard clauses (keep them) -----
                                if (cart.paid > 0) {
                                  message.warning(`${messages.errors.till_management.delete_payment_method}`);
                                  return;
                                }
                                if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                                  message.warning(`${messages.errors.cart.cart_switch_section}`);
                                  return;
                                }
                                if (showSendToKitchen || splitBillScreen) {
                                  message.warning(messages.errors.cart.cart_switch_section);
                                  return;
                                }
                                setIsCallCenterFlow(true); // <-- this triggers the centered page
                                setShowCallCenterPage(true); // (optional) reset any other UI flags you use
                                // setKeyValue("10");
                                history.push("/call-center");
                              } catch (error) {
                                console.error("Call Center button error:", error);
                                message.error("An error occurred while switching to Call Center mode");
                              }
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              <CustomerServiceOutlined style={{ color: keyValue === "9" ? "#FFF" : "#555359", fontSize: "3vh" }} />
                              <span className="posIcon" style={{ color: keyValue === "9" ? "#fff" : "#555359" }}>
                                {getMultilingualText("Call Center")}
                              </span>
                            </div>
                          </button>
                        </Col>
                      )}

                      {/* Back Button to return to Main Menu */}
                      <Col id="backButton" span={24} style={{ marginTop: "2vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #fff",
                          }}
                          onClick={() => {
                            (setShowMoreMenu(false), setKeyValue("0"));
                            const defaultIndex = sortedSaleTypes.findIndex((st) => st?.cwrSaletype?.fulfilmentType === defaultFulfilmentType);

                            setSelectedSaleTypeIndex(defaultIndex);
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                            {/* <BackIcon color="#555359" /> */}
                            <ArrowLeftOutlined style={{ color: "#555359" }} />
                            <span className="posIcon" style={{ color: "#555359" }}>
                              {getMultilingualText("Back")}
                            </span>
                          </div>
                        </button>
                      </Col>
                      {/* <Col span={24} style={{ marginTop: "32vh" }}></Col> */}
                    </>
                  )}
                </Scrollbars>
              </Row>
              <Col span={24} style={{ position: "absolute", bottom: 0, marginLeft: "0.5vw" }}>
                <div id="step6">
                  <button
                    className="cartMenuItems"
                    style={{ backgroundColor: "#fff", border: "1px solid #fff" }}
                    onClick={() => {
                        const hasActiveTables = tableCards.some(
                          (t) => t.statusType !== "OPN"
                        );

                        if (hasActiveTables) {
                          message.warning("Some tables still have ongoing orders. Finish them to logout.");
                          return;
                        }
                      if (cart.paid > 0) {
                        message.warning(`${messages.errors.till_management.delete_payment_method}`);
                        return;
                      }
                      if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      if (showSendToKitchen && hasUnfiredItems) {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      let posConfig = JSON.parse(localStorage.getItem("posConfig"));
                      if (matchedRep) {
                        const clearCookiesAndLocalStorage = () => {
                          const cookies = document.cookie.split(";");

                          for (const cookie of cookies) {
                            const eqPos = cookie.indexOf("=");
                            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                            const domain = `domain=${domainURL}`;
                            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict; ${domain}`;
                          }

                          localStorage.removeItem("tillSession");
                          window.location.assign("/");
                        };
                        clearCookiesAndLocalStorage();
                      } else {
                        if (posConfig?.shiftClose === "Y") {
                          if (posConfig?.showDenominations === "Y") {
                            history.push("/close-till");
                          } else if (posConfig?.showDenominations === "N") {
                            history.push("/close-till-all");
                          }
                        } else {
                          history.push("/");
                        }
                        handleKeyvalue("8");
                      }
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <img src={Logout} style={{ height: "7vh" }} />
                    </div>
                  </button>
                  {matchedRep && (
                    <span
                      style={{
                        color: "#929098",
                        fontWeight: 500,
                        fontSize: "0.8em",
                        textAlign: "center",
                        paddingLeft: "0.3vw",
                        paddingBottom: "0.5vh",
                      }}
                    >
                      {matchedRep.name}
                    </span>
                  )}
                </div>
              </Col>
            </div>

            <div style={{ width: "100%" }}>
              {keyValue === "0" ? (
                posConfig?.enableDineIn === "Y" ? (
                  <TableManagement
                    {...tableLayoutProps}
                    categorieFlag={categorieFlag}
                    setCategorieFlag={setCategorieFlag}
                    addDefinedProductWithAddons={addDefinedProductWithAddons}
                    restaurantProductCategory={restaurantProductCategory}
                    productsData={productsData}
                    pickProduct={pickProduct}
                    increaseProductQty={increaseProductQty}
                    decreaseProductQty={decreaseProductQty}
                    deleteProduct={deleteProduct}
                    setDisplayCustomerSearch={setDisplayCustomerSearch}
                    handleVoid={handleVoid}
                    paymentVisible={paymentVisible}
                    setPaymentVisible={setPaymentVisible}
                    cart={cart}
                    setCart={setCart}
                    deleteCart={deleteCart}
                    setKeyValue={setKeyValue}
                    handleOrder={handleOrder}
                    showProducts={showProducts}
                    setShowProducts={setShowProducts}
                    tableCards={tableCards}
                    setTableCards={setTableCards}
                    occupiedDataTablesData={occupiedDataTablesData}
                    setOcupiedTablesData={setOcupiedTablesData}
                    reservedTablesData={reservedTablesData}
                    setReservedTablesData={setReservedTablesData}
                    setProductsData={setProductsData}
                    saleTypeProducts={saleTypeProducts}
                    setSaleTypeProducts={setSaleTypeProducts}
                    requestPayment={requestPayment}
                    showOrderCompleteFlag={showOrderCompleteFlag}
                    setShowOrderCompleteFlag={setShowOrderCompleteFlag}
                    handleCashPayment={handleCashPayment}
                    mainTableData={mainTableData}
                    setMainTableData={setMainTableData}
                    fireItems={fireItems}
                    setFireItems={setFireItems}
                    fireMode={fireMode}
                    setFireMode={setFireMode}
                    pendingFireItems={pendingFireItems}
                    setPendingFireItems={setPendingFireItems}
                    handleCopyKOT={handleCopyKOT}
                    waitlistTab={waitlistTab}
                    setWaitlistTab={setWaitlistTab}
                    saveToWaitlist={saveToWaitlist}
                    waitlistForm={waitlistForm}
                    setWaitlistForm={setWaitlistForm}
                    validateWaitlistForm={validateWaitlistForm}
                    setWaitlistList={setWaitlistList}
                    waitlistList={waitlistList}
                    setWaitlistErrors={setWaitlistErrors}
                    waitlistErrors={waitlistErrors}
                    reservationList={reservationList}
                    setReservationList={setReservationList}
                    errors={errors}
                    setErrors={setErrors}
                    form={form}
                    setForm={setForm}
                    reserveModalOpen={reserveModalOpen}
                    setReserveModalOpen={setReserveModalOpen}
                    drawerOpen={drawerOpen}
                    setDrawerOpen={setDrawerOpen}
                    loadReservations={loadReservations}
                    waitlistDrawerOpen={waitlistDrawerOpen}
                    setWaitlistDrawerOpen={setWaitlistDrawerOpen}
                    loadWaitlistForUI={loadWaitlistForUI}
                    guestForm={guestForm}
                    setKioskUI={setKioskUI}
                    kioskLogin={kioskLogin}
                    isNewGuestCustomer={isNewGuestCustomer}
                    setIsNewGuestCustomer={setIsNewGuestCustomer}
                    reservationsBlank={reservationsBlank}
                    setReservationsBlank={setReservationsBlank}
                    mergeDrawerOpen={mergeDrawerOpen}
                    setMergeDrawerOpen={setMergeDrawerOpen}
                    handleTable={handleTable}
                    inputRef={inputRef}
                    displayReserveTablesPopup={displayReserveTablesPopup}
                    setDisplayReserveTablesPopup={setDisplayReserveTablesPopup}
                    handleReserveTable={handleReserveTable}
                    radioValue={radioValue}
                    setRadioValue={setRadioValue}
                    reserveTableForm={reserveTableForm}
                    handleNumberClick={handleNumberClick}
                    handleClick={handleClick}
                    setInputFields={setInputFields}
                    inputFields={inputFields}
                    numbers={numbers}
                    noOfPersons={noOfPersons}
                    setNumberOfPersons={setNumberOfPersons}
                    tableList={tableList}
                    setTableList={setTableList}
                    selectData={selectData}
                    setSelectData={setSelectData}
                    handleOnChange={handleOnChange}
                    guestMobile={guestMobile}
                    setGuestMobile={setGuestMobile}
                    reservePhone={reservePhone}
                    setReservePhone={setReservePhone}
                    addNewCustomer={addNewCustomer}
                    handleKeyvalue={handleKeyvalue}
                    setOederedData={setOederedData}
                    handleDisplayOk={handleDisplayOk}
                    productsList={productsList}
                    selectedProductId={selectedProductId}
                    setSelectedProductId={setSelectedProductId}
                    setsaleTypeProducts={setSaleTypeProducts}
                    addonSourceItem={addonSourceItem}
                    setAddonSourceItem={setAddonSourceItem}
                    showAddonsCustomizePopup={showAddonsCustomizePopup}
                    setShowAddonsCustomizePopUp={setShowAddonsCustomizePopUp}
                    addonRepeatDisabled={addonRepeatDisabled}
                    setAddonRepeatDisabled={setAddonRepeatDisabled}
                    setDisplayAddOnSelection={setDisplayAddOnSelection}       
                    displayAddOnSelection={displayAddOnSelection}             
                  />
                ) : posConfig?.enableTakeAway === "Y" ? (
                  <MenuLayout
                    {...tableLayoutProps}
                    categorieFlag={categorieFlag}
                    setCategorieFlag={setCategorieFlag}
                    setProductsData={setProductsData}
                    showSendToKitchen={showSendToKitchen}
                    setShowSendToKitchen={setShowSendToKitchen}
                    selectedProductForNotes={selectedProductForNotes}
                    notesValue={notesValue}
                    setNotesValue={setNotesValue}
                    setIsInputFocused={setIsInputFocused}
                    keyboardRef={keyboardRef}
                    setSelectedProductForNotes={setSelectedProductForNotes}
                    copyKOTVisible={copyKOTVisible}
                    setCopyKOTVisible={setCopyKOTVisible}
                    groupedFiredItems={groupedFiredItems}
                    setGroupedFiredItems={setGroupedFiredItems}
                    openCopyKOTModal={openCopyKOTModal}
                    selectedCopyItems={selectedCopyItems}
                    setSelectedCopyItems={setSelectedCopyItems}
                    setFireMode={setFireMode}
                    handleOrder={handleOrder}
                    setFireItems={setFireItems}
                    setOederedData={setOederedData}
                    handleDisplayOk={handleDisplayOk}
                    pendingFireItems={pendingFireItems}
                    setPendingFireItems={setPendingFireItems}
                    productsList={productsList}
                    setTableCards={setTableCards}
                    setTableList={setTableList}
                    openDisplayParkedBillModal={openDisplayParkedBillModal}
                    filterdParkedList={filterdParkedList}
                    setFilterdParkedList={setFilterdParkedList}
                    retrieveParkedData={retrieveParkedData}
                    discardMessage={discardMessage}
                    parkedList={parkedList}
                    setParkedList={setParkedList}
                    displayAddOnSelection={displayAddOnSelection}
                    setDisplayAddOnSelection={setDisplayAddOnSelection}
                    setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
                    addonSourceItem={addonSourceItem}
                    setAddonSourceItem={setAddonSourceItem}
                    showAddonsCustomizePopup={showAddonsCustomizePopup}
                    setShowAddonsCustomizePopUp={setShowAddonsCustomizePopUp}
                    addonRepeatDisabled={addonRepeatDisabled}
                    setAddonRepeatDisabled={setAddonRepeatDisabled}
                    saleTypeProducts={saleTypeProducts}
                    setsaleTypeProducts={setSaleTypeProducts}
                  />
                ) : (
                  <HomeDeliveryComponent
                    {...tableLayoutProps}
                    categorieFlag={categorieFlag}
                    setCategorieFlag={setCategorieFlag}
                    addDefinedProductWithAddons={addDefinedProductWithAddons}
                    restaurantProductCategory={restaurantProductCategory}
                    productsData={productsData}
                    pickProduct={pickProduct}
                    increaseProductQty={increaseProductQty}
                    decreaseProductQty={decreaseProductQty}
                    deleteProduct={deleteProduct}
                    setDisplayCustomerSearch={setDisplayCustomerSearch}
                    handleVoid={handleVoid}
                    setPaymentVisible={setPaymentVisible}
                    showProducts={showProducts}
                    setShowProducts={setShowProducts}
                    isSaleTypeFlag={isSaleTypeFlag}
                    setIsSaleTypeFlag={setIsSaleTypeFlag}
                    setProductsData={setProductsData}
                  />
                )
              ) : keyValue === "3" ? (
                <OrderListComponent
                  {...tableLayoutProps}
                  setSearchhistoryInput={setSearchhistoryInput}
                  sortedSaleTypes={sortedSaleTypes}
                  setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
                  addSelectedReturnProductsToCart={addSelectedReturnProductsToCart}
                  selectedReturnOrder={selectedReturnOrder}
                  setSelectedReturnOrder={setSelectedReturnOrder}
                  checkedKeys={checkedKeys}
                  setCheckedKeys={setCheckedKeys}
                  getProductData={getProductData}
                  handleSaveReturnCartRecord={handleSaveReturnCartRecord}
                  dataSource={dataSource}
                  setDataSource={setDataSource}
                  saleTypeProducts={saleTypeProducts}
                  setsaleTypeProducts={setSaleTypeProducts}
                  showReturnPurchase={showReturnPurchase}
                  setShowReturnPurchase={setShowReturnPurchase}
                  selectPurchaseBillForReturn={selectPurchaseBillForReturn}
                  retrunSearchType={retrunSearchType}
                  setReturnSearchType={setReturnSearchType}
                  searchReturnHistory={searchReturnHistory}
                />
              ) : keyValue === "5" ? (
                <CashManagement {...tableLayoutProps} />
              ) : keyValue === "8" ? (
                <CustomersComponent {...tableLayoutProps} />
              ) : keyValue === "2" ? (
                <MenuLayout
                  {...tableLayoutProps}
                  categorieFlag={categorieFlag}
                  setCategorieFlag={setCategorieFlag}
                  addDefinedProductWithAddons={addDefinedProductWithAddons}
                  cart={cart}
                  setCart={setCart}
                  setProductsData={setProductsData}
                  showSendToKitchen={showSendToKitchen}
                  setShowSendToKitchen={setShowSendToKitchen}
                  selectedProductForNotes={selectedProductForNotes}
                  notesValue={notesValue}
                  setNotesValue={setNotesValue}
                  setIsInputFocused={setIsInputFocused}
                  keyboardRef={keyboardRef}
                  setSelectedProductForNotes={setSelectedProductForNotes}
                  copyKOTVisible={copyKOTVisible}
                  setCopyKOTVisible={setCopyKOTVisible}
                  groupedFiredItems={groupedFiredItems}
                  setGroupedFiredItems={setGroupedFiredItems}
                  openCopyKOTModal={openCopyKOTModal}
                  selectedCopyItems={selectedCopyItems}
                  setSelectedCopyItems={setSelectedCopyItems}
                  handleOrder={handleOrder}
                  setFireItems={setFireItems}
                  setFireMode={setFireMode}
                  setOederedData={setOederedData}
                  handleDisplayOk={handleDisplayOk}
                  pendingFireItems={pendingFireItems}
                  setPendingFireItems={setPendingFireItems}
                  productsList={productsList}
                  setTableCards={setTableCards}
                  setTableList={setTableList}
                  openDisplayParkedBillModal={openDisplayParkedBillModal}
                  filterdParkedList={filterdParkedList}
                  setFilterdParkedList={setFilterdParkedList}
                  retrieveParkedData={retrieveParkedData}
                  discardMessage={discardMessage}
                  parkedList={parkedList}
                  setParkedList={setParkedList}
                  displayAddOnSelection={displayAddOnSelection}
                  setDisplayAddOnSelection={setDisplayAddOnSelection}
                  setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
                  addonSourceItem={addonSourceItem}
                  setAddonSourceItem={setAddonSourceItem}
                  showAddonsCustomizePopup={showAddonsCustomizePopup}
                  setShowAddonsCustomizePopUp={setShowAddonsCustomizePopUp}
                  addonRepeatDisabled={addonRepeatDisabled}
                  setAddonRepeatDisabled={setAddonRepeatDisabled}
                  saleTypeProducts={saleTypeProducts}
                  setsaleTypeProducts={setSaleTypeProducts}
                />
              ) : keyValue === "1" ? (
                <HomeDeliveryComponent
                  {...tableLayoutProps}
                  categorieFlag={categorieFlag}
                  setCategorieFlag={setCategorieFlag}
                  addDefinedProductWithAddons={addDefinedProductWithAddons}
                  restaurantProductCategory={restaurantProductCategory}
                  productsData={productsData}
                  pickProduct={pickProduct}
                  increaseProductQty={increaseProductQty}
                  decreaseProductQty={decreaseProductQty}
                  deleteProduct={deleteProduct}
                  setDisplayCustomerSearch={setDisplayCustomerSearch}
                  handleVoid={handleVoid}
                  setPaymentVisible={setPaymentVisible}
                  showProducts={showProducts}
                  setShowProducts={setShowProducts}
                  isSaleTypeFlag={isSaleTypeFlag}
                  setIsSaleTypeFlag={setIsSaleTypeFlag}
                  setProductsData={setProductsData}
                  setOederedData={setOederedData}
                  handleDisplayOk={handleDisplayOk}
                  pendingFireItems={pendingFireItems}
                  setPendingFireItems={setPendingFireItems}
                />
              ) : keyValue === "4" ? (
                <TableFeatures
                  reserveModalOpen={reserveModalOpen}
                  drawerOpen={drawerOpen}
                  setDrawerOpen={setDrawerOpen}
                  mergeDrawerOpen={mergeDrawerOpen}
                  closeMergeDrawer={() => setMergeDrawerOpen(false)}
                  waitlistDrawerOpen={waitlistDrawerOpen}
                  setWaitlistDrawerOpen={setWaitlistDrawerOpen}
                  loadWaitlistForUI={loadWaitlistForUI}
                  waitlistTab={waitlistTab}
                  setWaitlistTab={setWaitlistTab}
                  saveToWaitlist={saveToWaitlist}
                  validateWaitlistForm={validateWaitlistForm}
                  waitlistForm={waitlistForm}
                  setWaitlistForm={setWaitlistForm}
                  waitlistErrors={waitlistErrors}
                  setWaitlistErrors={setWaitlistErrors}
                  waitlistList={waitlistList}
                  setWaitlistList={setWaitlistList}
                  getWaitlist={getWaitlist}
                  reservationList={reservationList}
                  setReservationList={setReservationList}
                  errors={errors}
                  setErrors={setErrors}
                  form={form}
                  setForm={setForm}
                  selectData={selectData}
                  setSelectData={setSelectData}
                  tableList={tableList}
                  setTableList={setTableList}
                  setReserveModalOpen={setReserveModalOpen}
                  setTableCards={setTableCards}
                  setOcupiedTablesData={setOcupiedTablesData}
                  setReservedTablesData={setReservedTablesData}
                  setMainTableData={setMainTableData}
                  handleTable={handleTable}
                  loadReservations={loadReservations}
                  reservationsBlank={reservationsBlank}
                  setReservationsBlank={setReservationsBlank}
                  displayReserveTablesPopup={displayReserveTablesPopup}
                  setDisplayReserveTablesPopup={setDisplayReserveTablesPopup}
                  handleReserveTable={handleReserveTable}
                  radioValue={radioValue}
                  setRadioValue={setRadioValue}
                  guestForm={guestForm}
                  handleNumberClick={handleNumberClick}
                  reserveTableForm={reserveTableForm}
                  handleClick={handleClick}
                  inputFields={inputFields}
                  setInputFields={setInputFields}
                  numbers={numbers}
                  setNumberOfPersons={setNumberOfPersons}
                  noOfPersons={noOfPersons}
                  handleOnChange={handleOnChange}
                  setReservePhone={setReservePhone}
                  reservePhone={reservePhone}
                  addNewCustomer={addNewCustomer}
                  setCart={setCart}
                  cart={cart}
                  tableCards={tableCards}
                  selectedTable={selectedTable}
                  keyValue={keyValue}
                  setShowProducts={setShowProducts}
                  transferBill={transferBill}
                  setTransferBill={setTransferBill}
                  seatGuestDrawerOpen={seatGuestDrawerOpen}
                  setSeatGuestDrawerOpen={setSeatGuestDrawerOpen}
                  clearCartData={clearCartData}
                />
              ) : null}
            </div>
          </div>
        </div>
      )}
      <RestaurantModals
        selectedTable={selectedTable}
        orderFlags={orderFlags}
        setOrderFlags={setOrderFlags}
        getCustomerData={getCustomerData}
        tableList={tableList}
        setTableList={setTableList}
        displayAddOnSelection={displayAddOnSelection}
        handleAddOnModalClose={handleAddOnModalClose}
        addOnsList={addOnsList}
        selectedProduct={selectedProduct}
        selectedAddons={selectedAddons}
        handleAddOnValue={handleAddOnValue}
        currencyType={currencyType}
        selectedRowKeys={selectedRowKeys}
        selectedProductInCart={selectedProductInCart}
        decreaseProductQty={decreaseProductQty}
        handleQty={handleQty}
        increaseProductQty={increaseProductQty}
        handleAdd={handleAdd}
        selectedItemsModalOpen={selectedItemsModalOpen}
        setSelectedItemsModalOpen={setSelectedItemsModalOpen}
        selectProductInCart={selectProductInCart}
        handleDisplayOk={handleDisplayOk}
        displayOrderItemsModal={displayOrderItemsModal}
        orderStatus={orderStatus}
        selectedOrderStatus={selectedOrderStatus}
        handleOrderStatusSelection={handleOrderStatusSelection}
        handleOrderStatus={handleOrderStatus}
        setDisplayOrderItemsModal={setDisplayOrderItemsModal}
        orderDetails={orderDetails}
        handleStatusButton={handleStatusButton}
        barcodeOrderStatusModal={barcodeOrderStatusModal}
        setBarcodeOrderStatusModal={setBarcodeOrderStatusModal}
        barcodeOrderList={barcodeOrderList}
        handleBarcodeOrderPrint={handleBarcodeOrderPrint}
        handleAccept={handleAccept}
        cart={cart}
        tillData={tillData}
        openPaymentModal={openPaymentModal}
        billConfirmationModalOpen={billConfirmationModalOpen}
        setBillConfirmationModalOpen={setBillConfirmationModalOpen}
        parkedList={parkedList}
        openDisplayParkedBillModal={openDisplayParkedBillModal}
        orderTypeSelection={orderTypeSelection}
        manualDiscountModalVisible={manualDiscountModalVisible}
        setManualDiscountInput={setManualDiscountInput}
        setManualDiscountModalVisible={setManualDiscountModalVisible}
        notesModalOpen={notesModalOpen}
        setNotesModalOpen={setNotesModalOpen}
        handleCancelOrder={handleCancelOrder}
        showSendToKitchen={showSendToKitchen}
        setShowSendToKitchen={setShowSendToKitchen}
        orderedData={orderedData}
        setOederedData={setOederedData}
        fireMode={fireMode}
        setFireMode={setFireMode}
        pendingFireItems={pendingFireItems}
        setPendingFireItems={setPendingFireItems}
        setCart={setCart}
      />
      <RetailModals {...props} />
    </Spin>
  );
};
export default FBLayout;
